import { AdvancedImage } from "@cloudinary/react";
import { fill } from "@cloudinary/url-gen/actions/resize";
import DOMPurify from "dompurify";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { Editor } from "primereact/editor";
import { FileUpload } from "primereact/fileupload";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { TabPanel, TabView } from "primereact/tabview";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import localeText from "../../../../locale";
import ProductService from "../../../../service/ProductService";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { handleDescriptionLocale } from "../../../../utilities/locale/handleDescriptionLocale";
import { locale } from "../../../../utilities/locale/locale";
import useUploadFiles from "../../../../hooks/useUploadFiles";
import { localeISO } from "../../../../utilities/localeIso";
import Loading from "../../../../components/Loading/Loading";
import { formatPrice } from "../../../../utilities/formatPrice";
import { Tooltip } from "primereact/tooltip";
import { freightInputs, weightInputs } from "../NewProduct/inputs";
import {
  MANAGER_MAX_PERCENT_CASHBACK,
  MANAGER_MIN_PERCENT_CASHBACK,
  PARTNER_MAX_PERCENT_CASHBACK,
  PARTNER_MIN_PERCENT_CASHBACK,
  PLATFORM_PRODUCT_FEE,
  SELLER_MAX_PERCENT_CASHBACK,
  SELLER_MIN_PERCENT_CASHBACK,
} from "../../../../utilities/constants";
import IospediscoService from "../../../../service/iospedisco";
import GetInfoService from "../../../../service/GetInfoService";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import BanggoodService from "../../../../service/BanggoodService";

const EditingProduct = (props) => {
  const uploadOptions = {
    className: "hidden",
  };
  const { uploadAudio, uploadFile } = useUploadFiles();
  const downloadableId = parseInt(process.env.REACT_APP_DOWNLOADABLE_ID);
  const audioId = parseInt(process.env.REACT_APP_AUDIO_ID);
  const videoId = parseInt(process.env.REACT_APP_VIDEO_ID);
  const imageId_ = parseInt(process.env.REACT_APP_IMAGE_ID);
  const documentId = parseInt(process.env.REACT_APP_DOCUMENT_ID);

  const { product, plan, setEditingProductObj, getProductById } = props;
  const [typeProduct, setTypeProduct] = useState(
    product?.product?.service ? 2 : product?.product?.downloadable ? 3 : 1
  ); // 1 === product, 2 === service, 3 === downloadable
  const fileUploadDownloadable = useRef(null);
  const fileUploadSample = useRef(null);
  const [downloadableProduct, setDownloadableProduct] = useState(null);
  const [sampleProduct, setSampleProduct] = useState(null);
  const [downloadType, setDownloadType] = useState("");
  const [specificCategories, setSpecificCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [images, setImages] = useState([]);
  const [originalImages, setOriginalImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [image1, setImage1] = useState(null);
  const [image2, setImage2] = useState(null);
  const [image3, setImage3] = useState(null);
  const [image4, setImage4] = useState(null);
  const [image5, setImage5] = useState(null);
  const [image6, setImage6] = useState(null);
  const [image7, setImage7] = useState(null);
  const [image8, setImage8] = useState(null);
  const [image9, setImage9] = useState(null);
  const [image10, setImage10] = useState(null);
  const [title, setTitle] = useState(product.product.title);
  const [description, setDescription] = useState(product.product.description);
  const [priceUnique, setPriceUnique] = useState(product.product.priceUnique);
  const [promotionalPriceUnique, setPromotionalPriceUnique] = useState(
    product.product.promotionalPriceUnique ? product.product.promotionalPriceUnique : null
  );
  const [hasDiscount, setHasDiscount] = useState(
    product.product.promotionalPriceUnique ? true : false
  );
  const [stock, setStock] = useState(product.product.amountInStock);
  const [percentExtraCoin, setPercentExtracoin] = useState(product.product.percentExtraCoin);
  const [productState, setProductState] = useState(
    product?.product?.stateofproduct ? product?.product?.stateofproduct : null
  );
  const [productCondition, setProductCondition] = useState(
    product?.product?.conditionsUsedProduct ? product?.product?.conditionsUsedProduct : null
  );
  const [shippingService, setShippingService] = useState(false);
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);
  const [length, setLength] = useState(0);
  const [weight, setWeight] = useState(product.product.weight);
  const currency = product.product?.currency ? product.product.currency : "EUR";

  const [isLoadingPostalCode, setIsLoadingPostalCode] = useState(false);
  const [postalCode, setPostalCode] = useState("");
  const { showErrorToast } = useToastContext();

  const [freight, setFreight] = useState(0);
  const [isLoadingFreight, setIsLoadingFreight] = useState(false);
  const [freightPrice, setFreightPrice] = useState();
  const [isLoadingPrice, setIsLoadingPrice] = useState(true);
  const [handledFreightInputs, setHandledFreightInputs] = useState(freightInputs);
  const [percentComissionByShare, setPercentComissionByShare] = useState(
    product?.product?.percentComissionByShare ?? 0
  );
  const [hasComissionByShare, setHasComissionByShare] = useState(
    !!product?.product?.percentComissionByShare
  );

  const fileUploadRef1 = useRef(null);
  const fileUploadRef2 = useRef(null);
  const fileUploadRef3 = useRef(null);
  const fileUploadRef4 = useRef(null);
  const fileUploadRef5 = useRef(null);
  const fileUploadRef6 = useRef(null);
  const fileUploadRef7 = useRef(null);
  const fileUploadRef8 = useRef(null);
  const fileUploadRef9 = useRef(null);
  const fileUploadRef10 = useRef(null);

  const [techInfoKey1, setTechInfoKey1] = useState("");
  const [techInfoValue1, setTechInfoValue1] = useState("");
  const [techInfoKey2, setTechInfoKey2] = useState("");
  const [techInfoValue2, setTechInfoValue2] = useState("");
  const [techInfoKey3, setTechInfoKey3] = useState("");
  const [techInfoValue3, setTechInfoValue3] = useState("");
  const [techInfoKey4, setTechInfoKey4] = useState("");
  const [techInfoValue4, setTechInfoValue4] = useState("");
  const [techInfoKey5, setTechInfoKey5] = useState("");
  const [techInfoValue5, setTechInfoValue5] = useState("");
  const [technicalInfo, setTechnicalInfo] = useState([]);

  // Dynamic properties (depend on subcategory / sendShip checkbox on register product)
  const [brands, setBrands] = useState([]);
  const [brand, setBrand] = useState(null);
  const [model, setModel] = useState("");
  const [types, setTypes] = useState([]);
  const [type, setType] = useState(null);
  const [genderProducts, setGenderProducts] = useState([]);
  const [genderProduct, setGenderProduct] = useState(null);

  const [loaded, setLoaded] = useState(false);
  const toast = useRef(null);

  let percentMin;
  let percentMax;

  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState(null);
  const [subcategories, setSubcategories] = useState([]);
  const [subcategory, setSubcategory] = useState(null);
  const [banggoodPrice, setBanggoodPrice] = useState(null);

  const iospediscoService = new IospediscoService();
  const getInfoService = new GetInfoService();
  const banggoodService = new BanggoodService();

  useEffect(() => {
    let cancel = false;

    async function fetchCategories() {
      try {
        setLoading(true);
        const resCategories = await productService.getCategories();
        if (cancel) return;

        if (resCategories.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resCategories.messageCode)
              .message,
            life: 6000,
          });
          setLoading(false);
          return false;
        } else {
          const categoriesObjArr = [];

          resCategories.result.forEach((category) => {
            const categoryObj = {
              label:
                locale === "en"
                  ? category.descriptionEnglish
                  : locale === "it"
                  ? category.descriptionItalian
                  : locale === "pt"
                  ? category.descriptionPortuguese
                  : category.descriptionSpanish,
              imageid: category.imageid,
              id: category.id,
              subCategories: category.subCategories,
            };

            categoriesObjArr.push(categoryObj);
          });
          const category = categoriesObjArr.find((category) =>
            category.subCategories.find(
              (subcategory) => subcategory.id === product.product.subCategory.id
            )
          );

          const subcategoriesObjArr = [];

          category.subCategories.forEach((subcategory) => {
            const subcategoryObj = {
              label:
                locale === "en"
                  ? subcategory.descriptionEnglish
                  : locale === "it"
                  ? subcategory.descriptionItalian
                  : locale === "pt"
                  ? subcategory.descriptionPortuguese
                  : subcategory.descriptionSpanish,
              imageid: subcategory.imageid,
              id: subcategory.id,
            };

            subcategoriesObjArr.push(subcategoryObj);
          });

          const subcategory = subcategoriesObjArr.find(
            (subcategory) => subcategory.id === product.product.subCategory.id
          );
          let specificCategories;
          if (typeProduct !== 3) {
            specificCategories = categoriesObjArr.filter(
              (category) => category.id !== downloadableId
            );
          } else {
            specificCategories = categoriesObjArr.filter(
              (category) => category.id === downloadableId
            );
          }

          setCategories(categoriesObjArr);
          setSpecificCategories(specificCategories);
          setCategory(category);
          setSubcategories(subcategoriesObjArr);
          setSubcategory(subcategory);
          setLoading(false);
        }
      } catch (e) {
        if (e.status === 401 || e.status === 403) {
          localStorage.removeItem("__extraconomy_token");
          localStorage.removeItem("__extraconomy_username");
          window.location.replace("/login");
        }
        setLoading(false);
        console.log(e);
      }
    }

    fetchCategories();

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeCategory = (e) => {
    setCategory(e.value);

    const subcategoriesObjArr = [];

    e.value?.subCategories?.forEach((subcategory) => {
      const subcategoryObj = {
        label:
          locale === "en"
            ? subcategory.descriptionEnglish
            : locale === "it"
            ? subcategory.descriptionItalian
            : locale === "pt"
            ? subcategory.descriptionPortuguese
            : subcategory.descriptionSpanish,
        imageid: subcategory.imageid,
        id: subcategory.id,
      };

      subcategoriesObjArr.push(subcategoryObj);
    });

    setSubcategories(subcategoriesObjArr);
    setSubcategory(subcategoriesObjArr[0]);
  };

  switch (plan) {
    case "Partner":
      percentMin = PARTNER_MIN_PERCENT_CASHBACK;
      percentMax = PARTNER_MAX_PERCENT_CASHBACK;
      break;
    case "Manager":
      percentMin = MANAGER_MIN_PERCENT_CASHBACK;
      percentMax = MANAGER_MAX_PERCENT_CASHBACK;
      break;
    case "Seller":
      percentMin = SELLER_MIN_PERCENT_CASHBACK;
      percentMax = SELLER_MAX_PERCENT_CASHBACK;
      break;
    default:
      break;
  }

  const getLocationId = async () => {
    try {
      setIsLoadingFreight(true);
      const res = await iospediscoService.getLocatiobId({
        token: localStorage.getItem("__extraconomy_token"),
        postal_code: postalCode,
        country: "IT",
      });

      const locationResult = res?.locationResponse?.location_results;

      if (locationResult && locationResult[0]?.locations_list[0]?.id_location) {
        const locationId = locationResult[0]?.locations_list[0]?.id_location;
        const compare = await iospediscoService.compare({
          token: localStorage.getItem("__extraconomy_token"),
          id_location: locationId,
          width: width,
          height: height,
          weight: weight,
          depth: length,
          pickup_date: props?.userInfo?.amountDaysToPickUp,
        });

        const freight = compare?.comparisonResponse?.comparison_result;
        if (freight) {
          const freightValue = freight[0]?.comparison_items[0]?.total_amount_tax_excluded;
          if (props?.currency !== "EUR") {
            const resForex = await getInfoService.getForexRate("EUR", props?.currency);
            const resFreight = {
              price: freightValue * resForex.result,
              currency: props?.currency,
            };
            setFreightPrice(resFreight);
          } else {
            setFreightPrice({ price: freightValue, currency: "EUR" });
          }
          setIsLoadingFreight(false);
          return;
        }

        if (
          compare?.comparisonResponseError?.comparison_result[0]?.failure_reasons[0]?.includes(
            "minimum volume is 100 cubic centimeters"
          )
        ) {
          showErrorToast({ detail: "minimunValueError" });
        } else {
          showErrorToast({ code: 500000 });
        }
        setIsLoadingFreight(false);
      } else {
        showErrorToast({ detail: "addValidPostalCode" });
        setIsLoadingFreight(false);
      }
    } catch (e) {
      console.log(e);
      setIsLoadingFreight(false);
    }
  };

  useEffect(() => {
    let cancel = false;

    async function setData() {
      setIsLoadingPrice(true);
      const arrImages = [];

      product.product.imageid1 ? (arrImages[0] = product.product.imageid1) : (arrImages[0] = null);
      product.product.imageid2 ? (arrImages[1] = product.product.imageid2) : (arrImages[1] = null);
      product.product.imageid3 ? (arrImages[2] = product.product.imageid3) : (arrImages[2] = null);
      product.product.imageid4 ? (arrImages[3] = product.product.imageid4) : (arrImages[3] = null);
      product.product.imageid5 ? (arrImages[4] = product.product.imageid5) : (arrImages[4] = null);
      product.product.imageid6 ? (arrImages[5] = product.product.imageid6) : (arrImages[5] = null);
      product.product.imageid7 ? (arrImages[6] = product.product.imageid7) : (arrImages[6] = null);
      product.product.imageid8 ? (arrImages[7] = product.product.imageid8) : (arrImages[7] = null);
      product.product.imageid9 ? (arrImages[8] = product.product.imageid9) : (arrImages[8] = null);
      product.product.imageid10
        ? (arrImages[9] = product.product.imageid10)
        : (arrImages[9] = null);

      setImages(arrImages);
      setOriginalImages(arrImages);
      setLoaded(true);

      switch (product?.product?.shippingOption) {
        case "FREESENDCLOUD":
          setFreight(1);
          break;
        case "FREE":
          setFreight(2);
          break;
        case "PAID":
          setFreight(3);
          break;
        default:
          break;
      }
      setIsLoadingPrice(false);

      const subcategoryObj = {
        label:
          locale === "en"
            ? product.product.subCategory.descriptionEnglish
            : locale === "it"
            ? product.product.subCategory.descriptionItalian
            : locale === "pt"
            ? product.product.subCategory.descriptionPortuguese
            : product.product.subCategory.descriptionSpanish,
        imageid: product.product.subCategory.imageid,
        id: product.product.subCategory.id,
      };

      setSubcategory(subcategoryObj);

      if (!product.product.downloadable && !product.product.service) {
        setShippingService(true);
        setWeight(product.product.weight);
        setHeight(product.product.height);
        setWidth(product.product.width);
        setLength(product.product.length);
      }

      const resTechInfo = await productService.getTechnicalInfo(product.product.id);
      if (cancel) return;

      if (resTechInfo.messageCode !== 200001) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === resTechInfo.messageCode).message,
          life: 6000,
        });
        if (resTechInfo.messageCode === 500000) console.log(resTechInfo);
      } else {
        if (resTechInfo.result.length > 0) {
          setTechInfoKey1(resTechInfo.result[0].key);
          setTechInfoValue1(resTechInfo.result[0].value);
          if (resTechInfo.result[1]) {
            setTechInfoKey2(resTechInfo.result[1].key);
            setTechInfoValue2(resTechInfo.result[1].value);
          }
          if (resTechInfo.result[2]) {
            setTechInfoKey3(resTechInfo.result[2].key);
            setTechInfoValue3(resTechInfo.result[2].value);
          }
          if (resTechInfo.result[3]) {
            setTechInfoKey4(resTechInfo.result[3].key);
            setTechInfoValue4(resTechInfo.result[3].value);
          }
          if (resTechInfo.result[4]) {
            setTechInfoKey5(resTechInfo.result[4].key);
            setTechInfoValue5(resTechInfo.result[4].value);
          }
          setTechnicalInfo(resTechInfo.result);
        }
      }

      setLoading(false);
    }

    setData();

    return () => {
      cancel = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (productState === "NEW") setProductCondition(null);
  }, [productState]);

  function changeSelectedImage(index) {
    const deselectedImageElem = document.getElementById(`pi${currentImageIndex}`);
    deselectedImageElem.style.backgroundColor = "initial";
    deselectedImageElem.style.border = "1px solid #E0E0E0";

    const imageElem = document.getElementById(`pi${index}`);
    imageElem.style.backgroundColor = "#272360";
    imageElem.style.border = "1px solid #272360";

    setCurrentImageIndex(index);
  }

  const productService = new ProductService();

  async function uploadImages(image) {
    try {
      if (image && typeof image !== "string") {
        const res = await productService.postUploadImage(
          localStorage.getItem("__extraconomy_token"),
          image
        );
        if (res.messageCode !== 200000) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
            life: 6000,
          });
          return false;
        } else {
          return res.result;
        }
      } else {
        return null;
      }
    } catch (e) {
      if (e.status === 401) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      } else if (e.status === 500) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("unexpectedSystemBehaviour"),
          life: 6000,
        });
      } else {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("unexpectedErrorUploadImg"),
          life: 6000,
        });
      }
    }
  }

  const productStates = [
    { label: localeText("new"), value: "NEW" },
    { label: localeText("used"), value: "USED" },
  ];

  const productConditions = [
    { label: localeText("labeled"), value: "LABELED" },
    { label: localeText("notLabeled"), value: "NOTLABELED" },
    { label: localeText("excellent"), value: "EXCELLENT" },
    { label: localeText("good"), value: "GOOD" },
    { label: localeText("discrete"), value: "DISCRETE" },
  ];

  async function confirmChanges() {
    try {
      setLoading(true);
      if (
        (weight < 1 || length < 1 || width < 1 || height < 1) &&
        typeProduct === 1 &&
        !product.product.productIdBanggood
      ) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("dimensionsGreaterThanOne"),
          life: 6000,
        });
        setLoading(false);
        return;
      }

      if (
        !(weight * width * height >= 100) &&
        typeProduct === 1 &&
        !product.product.productIdBanggood
      ) {
        setLoading(false);
        showErrorToast({ detail: "minimunValueError" });
        return;
      }

      if (
        freight === 1 &&
        !freightPrice?.price &&
        product.product.shippingOption === "FREESENDCLOUD"
      ) {
        showErrorToast({ detail: "simulateLeastOneShippingValue" });
        setLoading(false);
        return;
      }

      if (
        freight === 1 &&
        hasDiscount &&
        promotionalPriceUnique < freightPrice?.price + freightPrice?.price * PLATFORM_PRODUCT_FEE &&
        product.product.shippingOption === "FREESENDCLOUD"
      ) {
        showErrorToast({ detail: "promotionalPriceMustBeLessThan" });
        setLoading(false);
        return;
      }

      if (category && category.id !== downloadableId && subcategory && stock === 0) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("stockGreaterThanZero"),
          life: 6000,
        });
        return;
      }

      if (productState === "USED" && !productCondition) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("pleaseFillOutAll"),
          life: 6000,
        });
        return;
      }

      if (
        title.length === 0 ||
        description.length === 0 ||
        priceUnique === 0 ||
        (brand && !model && typeProduct !== 3 && typeProduct !== 2)
      ) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("pleaseFillOutAll"),
          life: 6000,
        });
        setLoading(false);
        return;
      }

      if (!downloadableProduct && typeProduct === 3) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("pleaseUploadDownloadable"),
          life: 6000,
        });
        setLoading(false);
        return;
      }

      if (!sampleProduct && typeProduct === 3) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("pleaseUploadSample"),
          life: 6000,
        });
        setLoading(false);
        return;
      }

      let urldownload = null;
      let urldownloadsample = null;
      let cdnType = "CLOUDINARY";

      if (category.id === downloadableId) {
        if (downloadType === "AUDIO") {
          const urldownload_ = await uploadAudio(downloadableProduct);
          if (!urldownload_) return;
          const urlsample_ = await uploadAudio(sampleProduct);
          if (!urlsample_) return;

          urldownload = urldownload_;
          urldownloadsample = urlsample_;
          cdnType = "S3AWS";
        } else {
          const urldownload_ = await uploadFile(downloadableProduct);
          if (!urldownload_) return;
          const urlsample_ = await uploadFile(sampleProduct);
          if (!urlsample_) return;

          urldownload = urldownload_;
          urldownloadsample = urlsample_;
        }
      }

      const imagesUpload = [];

      if (images[0]) imagesUpload[0] = await uploadImages(images[0]);
      if (images[1]) imagesUpload[1] = await uploadImages(images[1]);
      if (images[2]) imagesUpload[2] = await uploadImages(images[2]);
      if (images[3]) imagesUpload[3] = await uploadImages(images[3]);
      if (images[4]) imagesUpload[4] = await uploadImages(images[4]);
      if (images[5]) imagesUpload[5] = await uploadImages(images[5]);
      if (images[6]) imagesUpload[6] = await uploadImages(images[6]);
      if (images[7]) imagesUpload[7] = await uploadImages(images[7]);
      if (images[8]) imagesUpload[8] = await uploadImages(images[8]);
      if (images[9]) imagesUpload[9] = await uploadImages(images[9]);

      let error = false;

      const NotDownloadableAndService = typeProduct !== 3 && typeProduct !== 2;

      const resEdit = await productService.postEditProduct(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username"),
        title,
        description,
        percentExtraCoin,
        imagesUpload[0] ? imagesUpload[0] : originalImages[0],
        imagesUpload[1] ? imagesUpload[1] : originalImages[1],
        imagesUpload[2] ? imagesUpload[2] : originalImages[2],
        imagesUpload[3] ? imagesUpload[3] : originalImages[3],
        imagesUpload[4] ? imagesUpload[4] : originalImages[4],
        product.product.id,
        weight > 0 && NotDownloadableAndService ? weight : 0,
        width > 0 && NotDownloadableAndService ? width : 0,
        height > 0 && NotDownloadableAndService ? height : 0,
        length > 0 && NotDownloadableAndService ? length : 0,
        subcategory.id,
        brand && NotDownloadableAndService ? brand.id : null,
        type && NotDownloadableAndService ? type.id : null,
        genderProduct && NotDownloadableAndService ? genderProduct.id : null,
        brand && NotDownloadableAndService ? model : null,
        typeProduct === 2 ? true : false,
        typeProduct === 3 ? true : false,
        typeProduct === 3 ? downloadType : null,
        typeProduct === 3 ? cdnType : null,
        typeProduct === 3 ? urldownload : null,
        typeProduct === 3 ? urldownloadsample : null,
        typeProduct !== 1
          ? null
          : freight === 1
          ? "FREESENDCLOUD"
          : freight === 2
          ? "FREE"
          : freight === 3
          ? "PAID"
          : freight === 4
          ? "PICKUP"
          : null,

        productCondition,
        productState,
        hasComissionByShare ? percentComissionByShare : 0,
        imagesUpload[5] ? imagesUpload[5] : originalImages[5],
        imagesUpload[6] ? imagesUpload[6] : originalImages[6],
        imagesUpload[7] ? imagesUpload[7] : originalImages[7],
        imagesUpload[8] ? imagesUpload[8] : originalImages[8],
        imagesUpload[9] ? imagesUpload[9] : originalImages[9]
      );
      if (resEdit.messageCode !== 200000) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === resEdit.messageCode).message,
          life: 6000,
        });
        if (resEdit.messageCode === 500000) console.log(resEdit);
        error = true;
      }

      if (product.productVariations.length === 0) {
        // Banggood foi descontinuado: o estoque desses produtos não pode mais ser alterado
        if (!product.product.productIdBanggood) {
          const resStock = await productService.postSetStockByProduct(
            localStorage.getItem("__extraconomy_token"),
            product.product.id,
            stock,
            localStorage.getItem("__extraconomy_username")
          );

          if (resStock.messageCode !== 200000) {
            toast.current.show({
              severity: "error",
              summary: localeText("error"),
              detail: localeText("data").find((msg) => msg.code === resStock.messageCode).message,
              life: 6000,
            });
            if (resStock.messageCode === 500000) console.log(resStock);
            error = true;
          }
        }

        const resPrice = await productService.postSetPriceByProduct(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username"),
          priceUnique,
          hasDiscount ? promotionalPriceUnique : null,
          product.product.id
        );

        if (resPrice.messageCode !== 200000) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resPrice.messageCode).message,
            life: 6000,
          });
          if (resPrice.messageCode === 500000) console.log(resPrice);
          error = true;
        }
      }

      // Register Technical Info
      if (techInfoKey1.length > 0 && techInfoValue1.length > 0 && !technicalInfo[0]) {
        const resRegisterTechInfo = await productService.postRegisterTechnicalInfo(
          localStorage.getItem("__extraconomy_token"),
          product.product.id,
          techInfoKey1,
          techInfoValue1,
          localStorage.getItem("__extraconomy_username")
        );

        if (resRegisterTechInfo.messageCode !== 200000) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resRegisterTechInfo.messageCode)
              .message,
            life: 6000,
          });
          if (resRegisterTechInfo.messageCode === 500000) console.log(resRegisterTechInfo);
          error = true;
        }
      }

      if (techInfoKey2.length > 0 && techInfoValue2.length > 0 && !technicalInfo[1]) {
        const resRegisterTechInfo = await productService.postRegisterTechnicalInfo(
          localStorage.getItem("__extraconomy_token"),
          product.product.id,
          techInfoKey2,
          techInfoValue2,
          localStorage.getItem("__extraconomy_username")
        );

        if (resRegisterTechInfo.messageCode !== 200000) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resRegisterTechInfo.messageCode)
              .message,
            life: 6000,
          });
          if (resRegisterTechInfo.messageCode === 500000) console.log(resRegisterTechInfo);
          error = true;
        }
      }

      if (techInfoKey3.length > 0 && techInfoValue3.length > 0 && !technicalInfo[2]) {
        const resRegisterTechInfo = await productService.postRegisterTechnicalInfo(
          localStorage.getItem("__extraconomy_token"),
          product.product.id,
          techInfoKey3,
          techInfoValue3,
          localStorage.getItem("__extraconomy_username")
        );

        if (resRegisterTechInfo.messageCode !== 200000) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resRegisterTechInfo.messageCode)
              .message,
            life: 6000,
          });
          if (resRegisterTechInfo.messageCode === 500000) console.log(resRegisterTechInfo);
          error = true;
        }
      }

      if (techInfoKey4.length > 0 && techInfoValue4.length > 0 && !technicalInfo[3]) {
        const resRegisterTechInfo = await productService.postRegisterTechnicalInfo(
          localStorage.getItem("__extraconomy_token"),
          product.product.id,
          techInfoKey4,
          techInfoValue4,
          localStorage.getItem("__extraconomy_username")
        );

        if (resRegisterTechInfo.messageCode !== 200000) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resRegisterTechInfo.messageCode)
              .message,
            life: 6000,
          });
          if (resRegisterTechInfo.messageCode === 500000) console.log(resRegisterTechInfo);
          error = true;
        }
      }

      if (techInfoKey5.length > 0 && techInfoValue5.length > 0 && !technicalInfo[4]) {
        const resRegisterTechInfo = await productService.postRegisterTechnicalInfo(
          localStorage.getItem("__extraconomy_token"),
          product.product.id,
          techInfoKey5,
          techInfoValue5,
          localStorage.getItem("__extraconomy_username")
        );

        if (resRegisterTechInfo.messageCode !== 200000) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resRegisterTechInfo.messageCode)
              .message,
            life: 6000,
          });
          if (resRegisterTechInfo.messageCode === 500000) console.log(resRegisterTechInfo);
          error = true;
        }
      }

      // Edit Technical Info
      if (
        technicalInfo[0] &&
        (techInfoKey1 !== technicalInfo[0].key || techInfoValue1 !== technicalInfo[0].value) &&
        techInfoKey1.length > 0 &&
        techInfoValue1.length > 0
      ) {
        const resEditTechInfo = await productService.postEditTechnicalInfo(
          localStorage.getItem("__extraconomy_token"),
          technicalInfo[0].id,
          techInfoKey1,
          techInfoValue1,
          localStorage.getItem("__extraconomy_username")
        );

        if (resEditTechInfo.messageCode !== 200000) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resEditTechInfo.messageCode)
              .message,
            life: 6000,
          });
          if (resEditTechInfo.messageCode === 500000) console.log(resEditTechInfo);
          error = true;
        }
      }

      if (
        technicalInfo[1] &&
        (techInfoKey2 !== technicalInfo[1].key || techInfoValue2 !== technicalInfo[1].value) &&
        techInfoKey2.length > 0 &&
        techInfoValue2.length > 0
      ) {
        const resEditTechInfo = await productService.postEditTechnicalInfo(
          localStorage.getItem("__extraconomy_token"),
          technicalInfo[1].id,
          techInfoKey2,
          techInfoValue2,
          localStorage.getItem("__extraconomy_username")
        );

        if (resEditTechInfo.messageCode !== 200000) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resEditTechInfo.messageCode)
              .message,
            life: 6000,
          });
          if (resEditTechInfo.messageCode === 500000) console.log(resEditTechInfo);
          error = true;
        }
      }

      if (
        technicalInfo[2] &&
        (techInfoKey3 !== technicalInfo[2].key || techInfoValue3 !== technicalInfo[2].value) &&
        techInfoKey3.length > 0 &&
        techInfoValue3.length > 0
      ) {
        const resEditTechInfo = await productService.postEditTechnicalInfo(
          localStorage.getItem("__extraconomy_token"),
          technicalInfo[2].id,
          techInfoKey3,
          techInfoValue3,
          localStorage.getItem("__extraconomy_username")
        );

        if (resEditTechInfo.messageCode !== 200000) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resEditTechInfo.messageCode)
              .message,
            life: 6000,
          });
          if (resEditTechInfo.messageCode === 500000) console.log(resEditTechInfo);
          error = true;
        }
      }

      if (
        technicalInfo[3] &&
        (techInfoKey4 !== technicalInfo[3].key || techInfoValue4 !== technicalInfo[3].value) &&
        techInfoKey4.length > 0 &&
        techInfoValue4.length > 0
      ) {
        const resEditTechInfo = await productService.postEditTechnicalInfo(
          localStorage.getItem("__extraconomy_token"),
          technicalInfo[3].id,
          techInfoKey4,
          techInfoValue4,
          localStorage.getItem("__extraconomy_username")
        );

        if (resEditTechInfo.messageCode !== 200000) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resEditTechInfo.messageCode)
              .message,
            life: 6000,
          });
          if (resEditTechInfo.messageCode === 500000) console.log(resEditTechInfo);
          error = true;
        }
      }

      if (
        technicalInfo[4] &&
        (techInfoKey5 !== technicalInfo[4].key || techInfoValue5 !== technicalInfo[4].value) &&
        techInfoKey5.length > 0 &&
        techInfoValue5.length > 0
      ) {
        const resEditTechInfo = await productService.postEditTechnicalInfo(
          localStorage.getItem("__extraconomy_token"),
          technicalInfo[4].id,
          techInfoKey5,
          techInfoValue5,
          localStorage.getItem("__extraconomy_username")
        );

        if (resEditTechInfo.messageCode !== 200000) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resEditTechInfo.messageCode)
              .message,
            life: 6000,
          });
          if (resEditTechInfo.messageCode === 500000) console.log(resEditTechInfo);
          error = true;
        }
      }

      if (!error) {
        const resRefreshTechInfo = await productService.getTechnicalInfo(product.product.id);

        if (resRefreshTechInfo.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resRefreshTechInfo.messageCode)
              .message,
            life: 6000,
          });
          if (resRefreshTechInfo.messageCode === 500000) console.log(resRefreshTechInfo);
          setLoading(false);
        }

        setTechnicalInfo(resRefreshTechInfo.result);

        toast.current.show({
          severity: "success",
          summary: localeText("success"),
          detail: localeText("productEditedSuccessfully"),
          life: 6000,
        });
        setLoading(false);
        props.setRetryFetchProducts(true);
        props.setEditingProductObj(null);
      }

      setLoading(false);
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      console.log(e);
    }
  }

  const renderHeader = () => {
    return (
      <span className="ql-formats">
        <select className="ql-size">
          <option defaultValue="">{localeText("normal")}</option>
          <option value="huge">{localeText("heading")}</option>
          <option value="large">{localeText("subheading")}</option>
        </select>
        <span className="ql-formats">
          <button className="ql-bold" aria-label="Bold"></button>
          <button className="ql-italic" aria-label="Italic"></button>
          <button className="ql-underline" aria-label="Underline"></button>
        </span>
        <span className="ql-formats">
          <button type="button" className="ql-list" value="ordered" aria-label="Ordered List">
            <svg viewBox="0 0 18 18">
              {" "}
              <line className="ql-stroke" x1="7" x2="15" y1="4" y2="4"></line>{" "}
              <line className="ql-stroke" x1="7" x2="15" y1="9" y2="9"></line>{" "}
              <line className="ql-stroke" x1="7" x2="15" y1="14" y2="14"></line>{" "}
              <line className="ql-stroke ql-thin" x1="2.5" x2="4.5" y1="5.5" y2="5.5"></line>{" "}
              <path
                className="ql-fill"
                d="M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z"
              ></path>{" "}
              <path
                className="ql-stroke ql-thin"
                d="M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156"
              ></path>{" "}
              <path
                className="ql-stroke ql-thin"
                d="M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109"
              ></path>{" "}
            </svg>
          </button>
          <button type="button" className="ql-list" value="bullet" aria-label="Unordered List">
            <svg viewBox="0 0 18 18">
              {" "}
              <line className="ql-stroke" x1="6" x2="15" y1="4" y2="4"></line>{" "}
              <line className="ql-stroke" x1="6" x2="15" y1="9" y2="9"></line>{" "}
              <line className="ql-stroke" x1="6" x2="15" y1="14" y2="14"></line>{" "}
              <line className="ql-stroke" x1="3" x2="3" y1="4" y2="4"></line>{" "}
              <line className="ql-stroke" x1="3" x2="3" y1="9" y2="9"></line>{" "}
              <line className="ql-stroke" x1="3" x2="3" y1="14" y2="14"></line>{" "}
            </svg>
          </button>
        </span>
      </span>
    );
  };

  const header = renderHeader();
  const updateBanggoodPrice = async () => {
    let banggoodProduct = await banggoodService.getProductInfo({
      product_id: product.product.productIdBanggood,
      lang: "EN",
    });
    let price = parseFloat(banggoodProduct.warehouse_list[0].warehouse_price);
    setBanggoodPrice(price);
  };
  async function clearTechInfo(id, index) {
    try {
      setLoading(true);

      const res = await productService.deleteTechnicalInfo(
        localStorage.getItem("__extraconomy_token"),
        id,
        localStorage.getItem("__extraconomy_username")
      );

      if (res.messageCode !== 200003) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        if (res.messageCode === 500000) console.log(res);
        setLoading(false);
        return;
      }

      switch (index + 1) {
        case 1:
          setTechInfoKey1("");
          setTechInfoValue1("");
          break;
        case 2:
          setTechInfoKey2("");
          setTechInfoValue2("");
          break;
        case 3:
          setTechInfoKey3("");
          setTechInfoValue3("");
          break;
        case 4:
          setTechInfoKey4("");
          setTechInfoValue4("");
          break;
        case 5:
          setTechInfoKey5("");
          setTechInfoValue5("");
          break;
        default:
          break;
      }

      const resRefreshTechInfo = await productService.getTechnicalInfo(product.product.id);

      if (resRefreshTechInfo.messageCode !== 200001) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === resRefreshTechInfo.messageCode)
            .message,
          life: 6000,
        });
        if (resRefreshTechInfo.messageCode === 500000) console.log(resRefreshTechInfo);
        setLoading(false);
      }

      setTechnicalInfo(resRefreshTechInfo.result);

      toast.current.show({
        severity: "info",
        summary: localeText("success"),
        detail: localeText("technicalInfoDeletedSuccessfully"),
        life: 6000,
      });

      setLoading(false);
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      console.log(e);
    }
  }

  async function checkZipCode(zip) {
    if (zip.length > 0) {
      try {
        const zip_ = zip.replace(/\D+/g, "");
        setIsLoadingPostalCode(true);

        const userCountry = await getInfoService.getUserCountry();
        const res = await getInfoService.getZipCodeInfo(zip_, userCountry);

        if (Array.isArray(res.results) && res.results.length === 0) {
          setIsLoadingPostalCode(false);
        } else if (res.results[`${zip_}`][0]) {
          setIsLoadingPostalCode(false);
        }
      } catch (e) {
        setIsLoadingPostalCode(false);
        console.log(e);
      }
    }
  }

  useEffect(() => {
    if (categories.length > 0 && subcategory) {
      setBrands([]);
      setTypes([]);
      setGenderProducts([]);
      setGenderProduct(null);
      setType(null);
      setBrand(null);

      const subcategoryFull = category.subCategories.find((subcat) => subcat.id === subcategory.id);

      if (subcategoryFull && subcategoryFull.brands.length > 0) {
        const brandsArr = [];

        subcategoryFull.brands.forEach((brand) => {
          const brandObj = { label: brand.description, id: brand.id };
          brandsArr.push(brandObj);
        });

        setBrands(brandsArr);
        product.product.brand
          ? setBrand({
              label: product.product.brand.description,
              id: product.product.brand.id,
            })
          : setBrand(brandsArr[0]);
        if (product.product.model) setModel(product.product.model);
      }

      if (subcategoryFull && subcategoryFull.types.length > 0) {
        const typesArr = [];

        subcategoryFull.types.forEach((type) => {
          let labelDescription = handleDescriptionLocale(type);

          const typeObj = {
            label: labelDescription,
            id: type.id,
          };

          typesArr.push(typeObj);
        });

        setTypes(typesArr);
        product.product.type
          ? setType({
              label: handleDescriptionLocale(product.product.type),
              id: product.product.type.id,
            })
          : setType(typesArr[0]);
      }

      if (subcategoryFull && subcategoryFull.genders.length > 0) {
        const genderProductsArr = [];

        subcategoryFull.genders.forEach((genderProduct) => {
          let labelDescription = handleDescriptionLocale(genderProduct);

          const genderProductObj = {
            label: labelDescription,
            id: genderProduct.id,
          };

          genderProductsArr.push(genderProductObj);
        });

        setGenderProducts(genderProductsArr);
        product.product.genderProduct
          ? setGenderProduct({
              label: handleDescriptionLocale(product.product.genderProduct),
              id: product.product.genderProduct.id,
            })
          : setGenderProduct(genderProductsArr[0]);
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subcategory]);

  useEffect(() => {
    const handleChangeCategory = () => {
      let specificCategories;
      if (typeProduct !== 3) {
        specificCategories = categories.filter((category) => category.id !== downloadableId);
      } else {
        specificCategories = categories.filter((category) => category.id === downloadableId);
      }

      const subcategoriesObjArr = [];
      specificCategories[0]?.subCategories?.forEach((subcategory) => {
        const subcategoryObj = {
          label:
            locale === "en"
              ? subcategory.descriptionEnglish
              : locale === "it"
              ? subcategory.descriptionItalian
              : locale === "pt"
              ? subcategory.descriptionPortuguese
              : subcategory.descriptionSpanish,
          imageid: subcategory.imageid,
          id: subcategory.id,
        };

        subcategoriesObjArr.push(subcategoryObj);
      });

      setSpecificCategories(specificCategories);
      setCategory(specificCategories[0]);
      setSubcategories(subcategoriesObjArr);
      setSubcategory(subcategoriesObjArr[0]);
    };

    if (categories && categories.length > 0) handleChangeCategory(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeProduct]);

  const NotDownloadableAndService = typeProduct !== 2 && typeProduct !== 3;

  useEffect(() => {
    setShippingService(typeProduct === 1 ? true : false);
  }, [typeProduct]);

  useEffect(() => {
    if (specificCategories[0]?.id === downloadableId) {
      if (subcategory?.id === audioId) setDownloadType("AUDIO");
      if (subcategory?.id === videoId) setDownloadType("VIDEO");
      if (subcategory?.id === imageId_) setDownloadType("IMAGE");
      if (subcategory?.id === documentId) setDownloadType("DOCUMENT");
    } else setDownloadType(""); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subcategory, specificCategories]);

  useEffect(() => {
    if (!product.product.productIdBanggood) {
      return;
    }
    updateBanggoodPrice();
    setHandledFreightInputs([
      {
        name: "freight",
        value: 2,
        label: "includedWithoutSendcloud",
        explain: "banggoodPaysFreight",
      },
    ]);
    setFreight(2);
  }, [product]);
  return (
    <div>
      <Toast ref={toast} />
      <Button
        icon="pi pi-arrow-left"
        onClick={() => setEditingProductObj(null)}
        label={localeText("goBackProductList")}
        className="mt-4"
      />

      <h3 className="mb-4">
        {localeText("editProduct")} "{product.product.title}"
      </h3>
      <hr />

      {product && (
        <div>
          {loading ? (
            <i className="pi pi-spin pi-spinner text-600 text-xl my-2"></i>
          ) : (
            <>
              {typeProduct && (
                <>
                  <div className="flex flex-wrap gap-3 my-4">
                    <div className="flex align-items-center">{localeText("typeOfProduct")}</div>
                    <div className="flex align-items-center">
                      <RadioButton
                        inputId="type1"
                        name="product"
                        value={1}
                        onChange={(e) => setTypeProduct(e.value)}
                        checked={typeProduct === 1}
                      />
                      <label htmlFor="type1" className="ml-2 cursor-pointer">
                        {localeText("product")}
                      </label>
                    </div>
                    <div className="flex align-items-center">
                      <RadioButton
                        inputId="type2"
                        name="product"
                        value={2}
                        onChange={(e) => setTypeProduct(e.value)}
                        checked={typeProduct === 2}
                      />
                      <label htmlFor="type2" className="ml-2 cursor-pointer">
                        {localeText("service")}
                      </label>
                    </div>
                    <div className="flex align-items-center">
                      <RadioButton
                        inputId="type3"
                        name="product"
                        value={3}
                        onChange={(e) => setTypeProduct(e.value)}
                        checked={typeProduct === 3}
                      />
                      <label htmlFor="type3" className="ml-2 cursor-pointer">
                        {localeText("downloadable")}
                      </label>
                    </div>
                  </div>
                </>
              )}
              {categories?.length > 0 && (
                <>
                  <label htmlFor="categories">{localeText("category")}:</label>
                  <Dropdown
                    name="categories"
                    value={category}
                    options={specificCategories}
                    style={{ minWidth: "200px" }}
                    onChange={handleChangeCategory}
                    className="ml-2 mr-4 mb-4 lg:mt-0 mt-2"
                  />
                </>
              )}
              {subcategories?.length > 0 && (
                <>
                  <br className="lg:hidden md:hidden block"></br>
                  <label htmlFor="subcategories">{localeText("subcategory")}:</label>
                  <Dropdown
                    name="subcategories"
                    value={subcategory}
                    options={subcategories}
                    onChange={(e) => setSubcategory(e.value)}
                    className="ml-2 mb-4 lg:mt-0 mt-2"
                    style={{ minWidth: "200px" }}
                  />
                </>
              )}
              <ul className="list-none mx-0 mb-4 p-0">
                {brands.length > 0 && NotDownloadableAndService && (
                  <li>
                    <div className="grid">
                      <div className="lg:col-1 col-12 p-0 ml-2">
                        <label>{localeText("model")}:</label>
                      </div>
                      <div className="lg:col-11 col-12 p-0">
                        <InputText
                          name="model"
                          className="my-2 mb-2 ml-2"
                          value={model}
                          onChange={(e) => setModel(e.target.value)}
                        />
                      </div>
                    </div>
                  </li>
                )}
                {types.length > 0 && NotDownloadableAndService && (
                  <li className="mt-2">
                    <div className="flex align-items-center">
                      <label style={{ minWidth: "60px" }}>{localeText("type")}:</label>
                      <Dropdown
                        name="types"
                        value={type}
                        options={types}
                        onChange={(e) => setType(e.value)}
                        className="ml-2"
                        style={{ minWidth: "200px" }}
                      />
                    </div>
                  </li>
                )}
                {genderProducts.length > 0 && NotDownloadableAndService && (
                  <li className="mt-2">
                    <div className="flex align-items-center">
                      <label style={{ minWidth: "60px" }}>{localeText("gender")}:</label>
                      <Dropdown
                        name="genderProducts"
                        value={genderProduct}
                        options={genderProducts}
                        onChange={(e) => setGenderProduct(e.value)}
                        className="ml-2"
                        style={{ minWidth: "200px" }}
                      />
                    </div>
                  </li>
                )}
              </ul>
            </>
          )}

          <h5 className="mb-3 mt-0">{localeText("productImages")}</h5>

          <ul className="my-0 p-0 list-none flex flex-wrap justify-content-center align-items-center">
            <li
              className="flex justify-content-end mb-4 mx-2"
              onClick={() => changeSelectedImage(0)}
            >
              <div
                style={{
                  border: "1px solid #E0E0E0",
                  outline: "2px solid #f7b005",
                  outlineOffset: "2px",
                }}
                className="border-round p-2 product-thumbnail"
                id={`pi0`}
              >
                {image1 ? (
                  <div
                    className="lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem bg-cover bg-center"
                    style={{ background: `url(${image1.objectURL})` }}
                  ></div>
                ) : (
                  <>
                    <div className="flex absolute justify-content-center align-items-center lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem">
                      <i className="pi pi-pencil text-2xl bg-primary border-3 border-0 border-circle p-3"></i>
                    </div>
                    <AdvancedImage
                      cldImg={cloudinaryInstance
                        .image(images[0])
                        .resize(fill().width(600).height(600))
                        .format("webp")}
                      className="lg:h-15rem md:h-10rem h-5rem"
                    />
                  </>
                )}
              </div>
            </li>

            {images[1] ? (
              <li
                className="flex justify-content-end mb-4 mx-2"
                onClick={() => changeSelectedImage(1)}
              >
                <div
                  style={{ border: "1px solid #E0E0E0" }}
                  className="border-round p-2 product-thumbnail"
                  id={`pi1`}
                >
                  {image2 ? (
                    <div
                      className="lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem bg-cover bg-center"
                      style={{ background: `url(${image2.objectURL})` }}
                    ></div>
                  ) : (
                    <>
                      <div className="flex absolute justify-content-center align-items-center lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem">
                        <i className="pi pi-pencil text-2xl bg-primary border-3 border-0 border-circle p-3"></i>
                      </div>
                      <AdvancedImage
                        cldImg={cloudinaryInstance
                          .image(images[1])
                          .resize(fill().width(600).height(600))
                          .format("webp")}
                        className="lg:h-15rem md:h-10rem h-5rem"
                      />
                    </>
                  )}
                </div>
              </li>
            ) : (
              <li className="flex justify-content-end mb-4 mx-2">
                <div
                  className="lg:h-16rem md:h-11rem h-6rem lg:w-16rem md:w-11rem w-6rem add-variation-img border-2 border-500 border-round border-dashed flex align-items-center justify-content-center cursor-pointer"
                  id={`pi1`}
                  onClick={() => changeSelectedImage(1)}
                >
                  <i className="pi pi-plus text-2xl text-500"></i>
                </div>
              </li>
            )}

            {images[2] ? (
              <li
                className="flex justify-content-end mb-4 mx-2"
                onClick={() => changeSelectedImage(2)}
              >
                <div
                  style={{ border: "1px solid #E0E0E0" }}
                  className="border-round p-2 product-thumbnail"
                  id={`pi2`}
                >
                  {image3 ? (
                    <div
                      className="lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem bg-cover bg-center"
                      style={{ background: `url(${image3.objectURL})` }}
                    ></div>
                  ) : (
                    <>
                      <div className="flex absolute justify-content-center align-items-center lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem">
                        <i className="pi pi-pencil text-2xl bg-primary border-3 border-0 border-circle p-3"></i>
                      </div>
                      <AdvancedImage
                        cldImg={cloudinaryInstance
                          .image(images[2])
                          .resize(fill().width(600).height(600))
                          .format("webp")}
                        className="lg:h-15rem md:h-10rem h-5rem"
                      />
                    </>
                  )}
                </div>
              </li>
            ) : (
              <li className="flex justify-content-end mb-4 mx-2">
                <div
                  className="lg:h-16rem md:h-11rem h-6rem lg:w-16rem md:w-11rem w-6rem add-variation-img border-2 border-500 border-round border-dashed flex align-items-center justify-content-center cursor-pointer"
                  id={`pi2`}
                  onClick={() => changeSelectedImage(2)}
                >
                  <i className="pi pi-plus text-2xl text-500"></i>
                </div>
              </li>
            )}

            {images[3] ? (
              <li
                className="flex justify-content-end mb-4 mx-2"
                onClick={() => changeSelectedImage(3)}
              >
                <div
                  style={{ border: "1px solid #E0E0E0" }}
                  className="border-round p-2 product-thumbnail"
                  id={`pi3`}
                >
                  {image4 ? (
                    <div
                      className="lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem bg-cover bg-center"
                      style={{ background: `url(${image4.objectURL})` }}
                    ></div>
                  ) : (
                    <>
                      <div className="flex absolute justify-content-center align-items-center lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem">
                        <i className="pi pi-pencil text-2xl bg-primary border-3 border-0 border-circle p-3"></i>
                      </div>
                      <AdvancedImage
                        cldImg={cloudinaryInstance
                          .image(images[3])
                          .resize(fill().width(600).height(600))
                          .format("webp")}
                        className="lg:h-15rem md:h-10rem h-5rem"
                      />
                    </>
                  )}
                </div>
              </li>
            ) : (
              <li className="flex justify-content-end mb-4 mx-2">
                <div
                  className="lg:h-16rem md:h-11rem h-6rem lg:w-16rem md:w-11rem w-6rem add-variation-img border-2 border-500 border-round border-dashed flex align-items-center justify-content-center cursor-pointer"
                  id={`pi3`}
                  onClick={() => changeSelectedImage(3)}
                >
                  <i className="pi pi-plus text-2xl text-500"></i>
                </div>
              </li>
            )}

            {images[4] ? (
              <li
                className="flex justify-content-end mb-4 mx-2"
                onClick={() => changeSelectedImage(4)}
              >
                <div
                  style={{ border: "1px solid #E0E0E0" }}
                  className="border-round p-2 product-thumbnail"
                  id={`pi4`}
                >
                  {image5 ? (
                    <div
                      className="lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem bg-cover bg-center"
                      style={{ background: `url(${image5.objectURL})` }}
                    ></div>
                  ) : (
                    <>
                      <div className="flex absolute justify-content-center align-items-center lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem">
                        <i className="pi pi-pencil text-2xl bg-primary border-3 border-0 border-circle p-3"></i>
                      </div>
                      <AdvancedImage
                        cldImg={cloudinaryInstance
                          .image(images[4])
                          .resize(fill().width(600).height(600))
                          .format("webp")}
                        className="lg:h-15rem md:h-10rem h-5rem"
                      />
                    </>
                  )}
                </div>
              </li>
            ) : (
              <li className="flex justify-content-end mb-4 mx-2">
                <div
                  className="lg:h-16rem md:h-11rem h-6rem lg:w-16rem md:w-11rem w-6rem add-variation-img border-2 border-500 border-round border-dashed flex align-items-center justify-content-center cursor-pointer"
                  id={`pi4`}
                  onClick={() => changeSelectedImage(4)}
                >
                  <i className="pi pi-plus text-2xl text-500"></i>
                </div>
              </li>
            )}

            {images[5] ? (
              <li
                className="flex justify-content-end mb-4 mx-2"
                onClick={() => changeSelectedImage(5)}
              >
                <div
                  style={{ border: "1px solid #E0E0E0" }}
                  className="border-round p-2 product-thumbnail"
                  id={`pi5`}
                >
                  {image6 ? (
                    <div
                      className="lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem bg-cover bg-center"
                      style={{ background: `url(${image6.objectURL})` }}
                    ></div>
                  ) : (
                    <>
                      <div className="flex absolute justify-content-center align-items-center lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem">
                        <i className="pi pi-pencil text-2xl bg-primary border-3 border-0 border-circle p-3"></i>
                      </div>
                      <AdvancedImage
                        cldImg={cloudinaryInstance
                          .image(images[5])
                          .resize(fill().width(600).height(600))
                          .format("webp")}
                        className="lg:h-15rem md:h-10rem h-5rem"
                      />
                    </>
                  )}
                </div>
              </li>
            ) : (
              <li className="flex justify-content-end mb-4 mx-2">
                <div
                  className="lg:h-16rem md:h-11rem h-6rem lg:w-16rem md:w-11rem w-6rem add-variation-img border-2 border-500 border-round border-dashed flex align-items-center justify-content-center cursor-pointer"
                  id={`pi5`}
                  onClick={() => changeSelectedImage(5)}
                >
                  <i className="pi pi-plus text-2xl text-500"></i>
                </div>
              </li>
            )}

            {images[6] ? (
              <li
                className="flex justify-content-end mb-4 mx-2"
                onClick={() => changeSelectedImage(6)}
              >
                <div
                  style={{ border: "1px solid #E0E0E0" }}
                  className="border-round p-2 product-thumbnail"
                  id={`pi6`}
                >
                  {image7 ? (
                    <div
                      className="lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem bg-cover bg-center"
                      style={{ background: `url(${image7?.objectURL})` }}
                    ></div>
                  ) : (
                    <>
                      <div className="flex absolute justify-content-center align-items-center lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem">
                        <i className="pi pi-pencil text-2xl bg-primary border-3 border-0 border-circle p-3"></i>
                      </div>
                      <AdvancedImage
                        cldImg={cloudinaryInstance
                          .image(images[6])
                          .resize(fill().width(600).height(600))
                          .format("webp")}
                        className="lg:h-15rem md:h-10rem h-5rem"
                      />
                    </>
                  )}
                </div>
              </li>
            ) : (
              <li className="flex justify-content-end mb-4 mx-2">
                <div
                  className="lg:h-16rem md:h-11rem h-6rem lg:w-16rem md:w-11rem w-6rem add-variation-img border-2 border-500 border-round border-dashed flex align-items-center justify-content-center cursor-pointer"
                  id={`pi6`}
                  onClick={() => changeSelectedImage(6)}
                >
                  <i className="pi pi-plus text-2xl text-500"></i>
                </div>
              </li>
            )}

            {images[7] ? (
              <li
                className="flex justify-content-end mb-4 mx-2"
                onClick={() => changeSelectedImage(7)}
              >
                <div
                  style={{ border: "1px solid #E0E0E0" }}
                  className="border-round p-2 product-thumbnail"
                  id={`pi7`}
                >
                  {image8 ? (
                    <div
                      className="lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem bg-cover bg-center"
                      style={{ background: `url(${image8?.objectURL})` }}
                    ></div>
                  ) : (
                    <>
                      <div className="flex absolute justify-content-center align-items-center lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem">
                        <i className="pi pi-pencil text-2xl bg-primary border-3 border-0 border-circle p-3"></i>
                      </div>
                      <AdvancedImage
                        cldImg={cloudinaryInstance
                          .image(images[7])
                          .resize(fill().width(600).height(600))
                          .format("webp")}
                        className="lg:h-15rem md:h-10rem h-5rem"
                      />
                    </>
                  )}
                </div>
              </li>
            ) : (
              <li className="flex justify-content-end mb-4 mx-2">
                <div
                  className="lg:h-16rem md:h-11rem h-6rem lg:w-16rem md:w-11rem w-6rem add-variation-img border-2 border-500 border-round border-dashed flex align-items-center justify-content-center cursor-pointer"
                  id={`pi7`}
                  onClick={() => changeSelectedImage(7)}
                >
                  <i className="pi pi-plus text-2xl text-500"></i>
                </div>
              </li>
            )}

            {images[8] ? (
              <li
                className="flex justify-content-end mb-4 mx-2"
                onClick={() => changeSelectedImage(8)}
              >
                <div
                  style={{ border: "1px solid #E0E0E0" }}
                  className="border-round p-2 product-thumbnail"
                  id={`pi8`}
                >
                  {image9 ? (
                    <div
                      className="lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem bg-cover bg-center"
                      style={{ background: `url(${image9?.objectURL})` }}
                    ></div>
                  ) : (
                    <>
                      <div className="flex absolute justify-content-center align-items-center lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem">
                        <i className="pi pi-pencil text-2xl bg-primary border-3 border-0 border-circle p-3"></i>
                      </div>
                      <AdvancedImage
                        cldImg={cloudinaryInstance
                          .image(images[8])
                          .resize(fill().width(600).height(600))
                          .format("webp")}
                        className="lg:h-15rem md:h-10rem h-5rem"
                      />
                    </>
                  )}
                </div>
              </li>
            ) : (
              <li className="flex justify-content-end mb-4 mx-2">
                <div
                  className="lg:h-16rem md:h-11rem h-6rem lg:w-16rem md:w-11rem w-6rem add-variation-img border-2 border-500 border-round border-dashed flex align-items-center justify-content-center cursor-pointer"
                  id={`pi8`}
                  onClick={() => changeSelectedImage(8)}
                >
                  <i className="pi pi-plus text-2xl text-500"></i>
                </div>
              </li>
            )}

            {images[9] ? (
              <li
                className="flex justify-content-end mb-4 mx-2"
                onClick={() => changeSelectedImage(9)}
              >
                <div
                  style={{ border: "1px solid #E0E0E0" }}
                  className="border-round p-2 product-thumbnail"
                  id={`pi9`}
                >
                  {image10 ? (
                    <div
                      className="lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem bg-cover bg-center"
                      style={{ background: `url(${image10.objectURL})` }}
                    ></div>
                  ) : (
                    <>
                      <div className="flex absolute justify-content-center align-items-center lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem">
                        <i className="pi pi-pencil text-2xl bg-primary border-3 border-0 border-circle p-3"></i>
                      </div>
                      <AdvancedImage
                        cldImg={cloudinaryInstance
                          .image(images[9])
                          .resize(fill().width(600).height(600))
                          .format("webp")}
                        className="lg:h-15rem md:h-10rem h-5rem"
                      />
                    </>
                  )}
                </div>
              </li>
            ) : (
              <li className="flex justify-content-end mb-4 mx-2">
                <div
                  className="lg:h-16rem md:h-11rem h-6rem lg:w-16rem md:w-11rem w-6rem add-variation-img border-2 border-500 border-round border-dashed flex align-items-center justify-content-center cursor-pointer"
                  id={`pi9`}
                  onClick={() => changeSelectedImage(9)}
                >
                  <i className="pi pi-plus text-2xl text-500"></i>
                </div>
              </li>
            )}
          </ul>

          <p className="text-xl" style={{ color: "#d1970a" }}>
            {localeText("thumbnailExplanation")}
          </p>

          <TabView
            activeIndex={currentImageIndex}
            onTabChange={(e) => changeSelectedImage(e.index)}
          >
            <TabPanel
              header={
                <div className="flex align-items-center">
                  <i className="pi pi-pencil mr-2"></i>
                  {localeText("image")} 1
                </div>
              }
            >
              {image1 ? (
                <div className="flex justify-content-center">
                  <Button
                    icon="pi pi-times"
                    className="p-button-danger p-button-rounded my-6 py-3 px-5 text-1xl"
                    onClick={() => {
                      const arrImages = [...images];
                      arrImages[0] = originalImages[0];
                      setImage1(null);
                      setImages(arrImages);
                    }}
                    label={localeText("removeImage")}
                  />
                </div>
              ) : (
                <FileUpload
                  uploadOptions={uploadOptions}
                  chooseLabel={localeText("choose")}
                  cancelLabel={localeText("cancel")}
                  name="demo"
                  onSelect={(e) => {
                    if (e.files[0].size / 1024 / 1024 > 5) {
                      fileUploadRef1.current.clear();
                      toast.current.show({
                        severity: "error",
                        summary: localeText("error"),
                        detail: localeText("fileSizeTooBig"),
                        life: 6000,
                      });
                      return false;
                    }

                    const arrImages = [...images];
                    arrImages[0] = e.files[0];
                    setImages(arrImages);
                    setImage1(e.files[0]);
                  }}
                  onClear={() => {
                    const arrImages = [...images];
                    arrImages[0] = originalImages[0];
                    setImage1(null);
                    setImages(arrImages);
                  }}
                  onRemove={() => {
                    fileUploadRef1.current.clear();
                    const arrImages = [...images];
                    arrImages[0] = originalImages[0];
                    setImage1(null);
                    setImages(arrImages);
                  }}
                  onError={() => {
                    fileUploadRef1.current.clear();
                    const arrImages = [...images];
                    arrImages[0] = originalImages[0];
                    setImage1(null);
                    setImages(arrImages);
                  }}
                  onValidationFail={() => {
                    fileUploadRef1.current.clear();
                    const arrImages = [...images];
                    arrImages[0] = originalImages[0];
                    setImage1(null);
                    setImages(arrImages);
                  }}
                  accept="image/*"
                  ref={fileUploadRef1}
                  emptyTemplate={
                    <div className="text-center">
                      <i className="pi pi-upload text-400" style={{ fontSize: "2em" }}></i>
                      <h5 className="text-400">{localeText("dragImgFile")}</h5>
                    </div>
                  }
                  className="w-full h-auto"
                />
              )}
            </TabPanel>

            <TabPanel
              header={
                <>
                  {images[1] ? (
                    <div className="flex align-items-center">
                      <i className="pi pi-pencil mr-2"></i>
                      {localeText("image")} 2
                    </div>
                  ) : (
                    <>+ {localeText("add")}</>
                  )}
                </>
              }
            >
              {image2 ? (
                <div className="flex justify-content-center">
                  <Button
                    icon="pi pi-times"
                    className="p-button-danger p-button-rounded my-6 py-3 px-5 text-1xl"
                    onClick={() => {
                      const arrImages = [...images];
                      arrImages[1] = originalImages[1];
                      setImage2(null);
                      setImages(arrImages);
                    }}
                    label={localeText("removeImage")}
                  />
                </div>
              ) : (
                <FileUpload
                  uploadOptions={uploadOptions}
                  chooseLabel={localeText("choose")}
                  cancelLabel={localeText("cancel")}
                  name="demo"
                  onSelect={(e) => {
                    if (e.files[0].size / 1024 / 1024 > 5) {
                      fileUploadRef2.current.clear();
                      toast.current.show({
                        severity: "error",
                        summary: localeText("error"),
                        detail: localeText("fileSizeTooBig"),
                        life: 6000,
                      });
                      return false;
                    }

                    const arrImages = [...images];
                    arrImages[1] = e.files[0];
                    setImages(arrImages);
                    setImage2(e.files[0]);
                  }}
                  onClear={() => {
                    const arrImages = [...images];
                    arrImages[1] = originalImages[1];
                    setImage2(null);
                    setImages(arrImages);
                  }}
                  onRemove={() => {
                    fileUploadRef2.current.clear();
                    const arrImages = [...images];
                    arrImages[1] = originalImages[1];
                    setImage2(null);
                    setImages(arrImages);
                  }}
                  onError={() => {
                    fileUploadRef2.current.clear();
                    const arrImages = [...images];
                    arrImages[1] = originalImages[1];
                    setImage2(null);
                    setImages(arrImages);
                  }}
                  onValidationFail={() => {
                    fileUploadRef2.current.clear();
                    const arrImages = [...images];
                    arrImages[1] = originalImages[1];
                    setImage2(null);
                    setImages(arrImages);
                  }}
                  accept="image/*"
                  ref={fileUploadRef2}
                  emptyTemplate={
                    <div className="text-center">
                      <i className="pi pi-upload text-400" style={{ fontSize: "2em" }}></i>
                      <h5 className="text-400">{localeText("dragImgFile")}</h5>
                    </div>
                  }
                  className="w-full h-auto"
                />
              )}
            </TabPanel>

            <TabPanel
              header={
                <>
                  {images[2] ? (
                    <div className="flex align-items-center">
                      <i className="pi pi-pencil mr-2"></i>
                      {localeText("image")} 3
                    </div>
                  ) : (
                    <>+ {localeText("add")}</>
                  )}
                </>
              }
            >
              {image3 ? (
                <div className="flex justify-content-center">
                  <Button
                    icon="pi pi-times"
                    className="p-button-danger p-button-rounded my-6 py-3 px-5 text-1xl"
                    onClick={() => {
                      const arrImages = [...images];
                      arrImages[2] = originalImages[2];
                      setImage3(null);
                      setImages(arrImages);
                    }}
                    label={localeText("removeImage")}
                  />
                </div>
              ) : (
                <FileUpload
                  uploadOptions={uploadOptions}
                  chooseLabel={localeText("choose")}
                  cancelLabel={localeText("cancel")}
                  name="demo"
                  onSelect={(e) => {
                    if (e.files[0].size / 1024 / 1024 > 5) {
                      fileUploadRef3.current.clear();
                      toast.current.show({
                        severity: "error",
                        summary: localeText("error"),
                        detail: localeText("fileSizeTooBig"),
                        life: 6000,
                      });
                      return false;
                    }

                    const arrImages = [...images];
                    arrImages[2] = e.files[0];
                    setImages(arrImages);
                    setImage3(e.files[0]);
                  }}
                  onClear={() => setImage3(null)}
                  onRemove={() => {
                    fileUploadRef3.current.clear();
                    const arrImages = [...images];
                    arrImages[2] = originalImages[2];
                    setImage3(null);
                    setImages(arrImages);
                  }}
                  onError={() => {
                    fileUploadRef3.current.clear();
                    const arrImages = [...images];
                    arrImages[2] = originalImages[2];
                    setImage3(null);
                    setImages(arrImages);
                  }}
                  onValidationFail={() => {
                    fileUploadRef3.current.clear();
                    const arrImages = [...images];
                    arrImages[2] = originalImages[2];
                    setImage3(null);
                    setImages(arrImages);
                  }}
                  accept="image/*"
                  ref={fileUploadRef3}
                  emptyTemplate={
                    <div className="text-center">
                      <i className="pi pi-upload text-400" style={{ fontSize: "2em" }}></i>
                      <h5 className="text-400">{localeText("dragImgFile")}</h5>
                    </div>
                  }
                  className="w-full h-auto"
                />
              )}
            </TabPanel>

            <TabPanel
              header={
                <>
                  {images[3] ? (
                    <div className="flex align-items-center">
                      <i className="pi pi-pencil mr-2"></i>
                      {localeText("image")} 4
                    </div>
                  ) : (
                    <>+ {localeText("add")}</>
                  )}
                </>
              }
            >
              {image4 ? (
                <div className="flex justify-content-center">
                  <Button
                    icon="pi pi-times"
                    className="p-button-danger p-button-rounded my-6 py-3 px-5 text-1xl"
                    onClick={() => {
                      const arrImages = [...images];
                      arrImages[3] = originalImages[3];
                      setImage4(null);
                      setImages(arrImages);
                    }}
                    label={localeText("removeImage")}
                  />
                </div>
              ) : (
                <FileUpload
                  uploadOptions={uploadOptions}
                  chooseLabel={localeText("choose")}
                  cancelLabel={localeText("cancel")}
                  name="demo"
                  onSelect={(e) => {
                    if (e.files[0].size / 1024 / 1024 > 5) {
                      fileUploadRef4.current.clear();
                      toast.current.show({
                        severity: "error",
                        summary: localeText("error"),
                        detail: localeText("fileSizeTooBig"),
                        life: 6000,
                      });
                      return false;
                    }

                    const arrImages = [...images];
                    arrImages[3] = e.files[0];
                    setImages(arrImages);
                    setImage4(e.files[0]);
                  }}
                  onClear={() => setImage4(null)}
                  onRemove={() => {
                    fileUploadRef4.current.clear();
                    const arrImages = [...images];
                    arrImages[3] = originalImages[3];
                    setImage4(null);
                    setImages(arrImages);
                  }}
                  onError={() => {
                    fileUploadRef4.current.clear();
                    const arrImages = [...images];
                    arrImages[3] = originalImages[3];
                    setImage4(null);
                    setImages(arrImages);
                  }}
                  onValidationFail={() => {
                    fileUploadRef4.current.clear();
                    const arrImages = [...images];
                    arrImages[3] = originalImages[3];
                    setImage4(null);
                    setImages(arrImages);
                  }}
                  accept="image/*"
                  ref={fileUploadRef4}
                  emptyTemplate={
                    <div className="text-center">
                      <i className="pi pi-upload text-400" style={{ fontSize: "2em" }}></i>
                      <h5 className="text-400">{localeText("dragImgFile")}</h5>
                    </div>
                  }
                  className="w-full h-auto"
                />
              )}
            </TabPanel>

            <TabPanel
              header={
                <>
                  {images[4] ? (
                    <div className="flex align-items-center">
                      <i className="pi pi-pencil mr-2"></i>
                      {localeText("image")} 5
                    </div>
                  ) : (
                    <>+ {localeText("add")}</>
                  )}
                </>
              }
            >
              {image5 ? (
                <div className="flex justify-content-center">
                  <Button
                    icon="pi pi-times"
                    className="p-button-danger p-button-rounded my-6 py-3 px-5 text-1xl"
                    onClick={() => {
                      const arrImages = [...images];
                      arrImages[4] = originalImages[4];
                      setImage5(null);
                      setImages(arrImages);
                    }}
                    label={localeText("removeImage")}
                  />
                </div>
              ) : (
                <FileUpload
                  uploadOptions={uploadOptions}
                  chooseLabel={localeText("choose")}
                  cancelLabel={localeText("cancel")}
                  name="demo"
                  onSelect={(e) => {
                    if (e.files[0].size / 1024 / 1024 > 5) {
                      fileUploadRef5.current.clear();
                      toast.current.show({
                        severity: "error",
                        summary: localeText("error"),
                        detail: localeText("fileSizeTooBig"),
                        life: 6000,
                      });
                      return false;
                    }

                    const arrImages = [...images];
                    arrImages[4] = e.files[0];
                    setImages(arrImages);
                    setImage5(e.files[0]);
                  }}
                  onClear={() => setImage5(null)}
                  onRemove={() => {
                    fileUploadRef5.current.clear();
                    const arrImages = [...images];
                    arrImages[4] = originalImages[4];
                    setImage5(null);
                    setImages(arrImages);
                  }}
                  onError={() => {
                    fileUploadRef5.current.clear();
                    const arrImages = [...images];
                    arrImages[4] = originalImages[4];
                    setImage5(null);
                    setImages(arrImages);
                  }}
                  onValidationFail={() => {
                    fileUploadRef5.current.clear();
                    const arrImages = [...images];
                    arrImages[4] = originalImages[4];
                    setImage5(null);
                    setImages(arrImages);
                  }}
                  accept="image/*"
                  ref={fileUploadRef5}
                  emptyTemplate={
                    <div className="text-center">
                      <i className="pi pi-upload text-400" style={{ fontSize: "2em" }}></i>
                      <h5 className="text-400">{localeText("dragImgFile")}</h5>
                    </div>
                  }
                  className="w-full h-auto"
                />
              )}
            </TabPanel>

            <TabPanel
              header={
                <>
                  {images[5] ? (
                    <div className="flex align-items-center">
                      <i className="pi pi-pencil mr-2"></i>
                      {localeText("image")} 6
                    </div>
                  ) : (
                    <>+ {localeText("add")}</>
                  )}
                </>
              }
            >
              {image6 ? (
                <div className="flex justify-content-center">
                  <Button
                    icon="pi pi-times"
                    className="p-button-danger p-button-rounded my-6 py-3 px-5 text-1xl"
                    onClick={() => {
                      const arrImages = [...images];
                      arrImages[5] = originalImages[5];
                      setImage6(null);
                      setImages(arrImages);
                    }}
                    label={localeText("removeImage")}
                  />
                </div>
              ) : (
                <FileUpload
                  uploadOptions={uploadOptions}
                  chooseLabel={localeText("choose")}
                  cancelLabel={localeText("cancel")}
                  name="demo"
                  onSelect={(e) => {
                    if (e.files[0].size / 1024 / 1024 > 5) {
                      fileUploadRef6.current.clear();
                      toast.current.show({
                        severity: "error",
                        summary: localeText("error"),
                        detail: localeText("fileSizeTooBig"),
                        life: 6000,
                      });
                      return false;
                    }

                    const arrImages = [...images];
                    arrImages[5] = e.files[0];
                    setImages(arrImages);
                    setImage6(e.files[0]);
                  }}
                  onClear={() => setImage6(null)}
                  onRemove={() => {
                    fileUploadRef5.current.clear();
                    const arrImages = [...images];
                    arrImages[5] = originalImages[5];
                    setImage6(null);
                    setImages(arrImages);
                  }}
                  onError={() => {
                    fileUploadRef6.current.clear();
                    const arrImages = [...images];
                    arrImages[5] = originalImages[5];
                    setImage6(null);
                    setImages(arrImages);
                  }}
                  onValidationFail={() => {
                    fileUploadRef6.current.clear();
                    const arrImages = [...images];
                    arrImages[5] = originalImages[5];
                    setImage6(null);
                    setImages(arrImages);
                  }}
                  accept="image/*"
                  ref={fileUploadRef6}
                  emptyTemplate={
                    <div className="text-center">
                      <i className="pi pi-upload text-400" style={{ fontSize: "2em" }}></i>
                      <h5 className="text-400">{localeText("dragImgFile")}</h5>
                    </div>
                  }
                  className="w-full h-auto"
                />
              )}
            </TabPanel>

            <TabPanel
              header={
                <>
                  {images[6] ? (
                    <div className="flex align-items-center">
                      <i className="pi pi-pencil mr-2"></i>
                      {localeText("image")} 7
                    </div>
                  ) : (
                    <>+ {localeText("add")}</>
                  )}
                </>
              }
            >
              {image7 ? (
                <div className="flex justify-content-center">
                  <Button
                    icon="pi pi-times"
                    className="p-button-danger p-button-rounded my-6 py-3 px-5 text-1xl"
                    onClick={() => {
                      const arrImages = [...images];
                      arrImages[6] = originalImages[6];
                      setImage7(null);
                      setImages(arrImages);
                    }}
                    label={localeText("removeImage")}
                  />
                </div>
              ) : (
                <FileUpload
                  uploadOptions={uploadOptions}
                  chooseLabel={localeText("choose")}
                  cancelLabel={localeText("cancel")}
                  name="demo"
                  onSelect={(e) => {
                    if (e.files[0].size / 1024 / 1024 > 5) {
                      fileUploadRef7.current.clear();
                      toast.current.show({
                        severity: "error",
                        summary: localeText("error"),
                        detail: localeText("fileSizeTooBig"),
                        life: 6000,
                      });
                      return false;
                    }

                    const arrImages = [...images];
                    arrImages[6] = e.files[0];
                    setImages(arrImages);
                    setImage7(e.files[0]);
                  }}
                  onClear={() => setImage6(null)}
                  onRemove={() => {
                    fileUploadRef7.current.clear();
                    const arrImages = [...images];
                    arrImages[6] = originalImages[6];
                    setImage7(null);
                    setImages(arrImages);
                  }}
                  onError={() => {
                    fileUploadRef7.current.clear();
                    const arrImages = [...images];
                    arrImages[6] = originalImages[6];
                    setImage7(null);
                    setImages(arrImages);
                  }}
                  onValidationFail={() => {
                    fileUploadRef7.current.clear();
                    const arrImages = [...images];
                    arrImages[6] = originalImages[6];
                    setImage7(null);
                    setImages(arrImages);
                  }}
                  accept="image/*"
                  ref={fileUploadRef7}
                  emptyTemplate={
                    <div className="text-center">
                      <i className="pi pi-upload text-400" style={{ fontSize: "2em" }}></i>
                      <h5 className="text-400">{localeText("dragImgFile")}</h5>
                    </div>
                  }
                  className="w-full h-auto"
                />
              )}
            </TabPanel>

            <TabPanel
              header={
                <>
                  {images[7] ? (
                    <div className="flex align-items-center">
                      <i className="pi pi-pencil mr-2"></i>
                      {localeText("image")} 8
                    </div>
                  ) : (
                    <>+ {localeText("add")}</>
                  )}
                </>
              }
            >
              {image8 ? (
                <div className="flex justify-content-center">
                  <Button
                    icon="pi pi-times"
                    className="p-button-danger p-button-rounded my-6 py-3 px-5 text-1xl"
                    onClick={() => {
                      const arrImages = [...images];
                      arrImages[7] = originalImages[7];
                      setImage8(null);
                      setImages(arrImages);
                    }}
                    label={localeText("removeImage")}
                  />
                </div>
              ) : (
                <FileUpload
                  uploadOptions={uploadOptions}
                  chooseLabel={localeText("choose")}
                  cancelLabel={localeText("cancel")}
                  name="demo"
                  onSelect={(e) => {
                    if (e.files[0].size / 1024 / 1024 > 5) {
                      fileUploadRef8.current.clear();
                      toast.current.show({
                        severity: "error",
                        summary: localeText("error"),
                        detail: localeText("fileSizeTooBig"),
                        life: 6000,
                      });
                      return false;
                    }

                    const arrImages = [...images];
                    arrImages[7] = e.files[0];
                    setImage8(e.files[0]);
                    setImages(arrImages);
                  }}
                  onClear={() => setImage8(null)}
                  onRemove={() => {
                    fileUploadRef8.current.clear();
                    const arrImages = [...images];
                    arrImages[7] = originalImages[7];
                    setImage8(null);
                    setImages(arrImages);
                  }}
                  onError={() => {
                    fileUploadRef8.current.clear();
                    const arrImages = [...images];
                    arrImages[7] = originalImages[7];
                    setImage8(null);
                    setImages(arrImages);
                  }}
                  onValidationFail={() => {
                    fileUploadRef8.current.clear();
                    const arrImages = [...images];
                    arrImages[7] = originalImages[7];
                    setImage8(null);
                    setImages(arrImages);
                  }}
                  accept="image/*"
                  ref={fileUploadRef8}
                  emptyTemplate={
                    <div className="text-center">
                      <i className="pi pi-upload text-400" style={{ fontSize: "2em" }}></i>
                      <h5 className="text-400">{localeText("dragImgFile")}</h5>
                    </div>
                  }
                  className="w-full h-auto"
                />
              )}
            </TabPanel>

            <TabPanel
              header={
                <>
                  {images[8] ? (
                    <div className="flex align-items-center">
                      <i className="pi pi-pencil mr-2"></i>
                      {localeText("image")} 9
                    </div>
                  ) : (
                    <>+ {localeText("add")}</>
                  )}
                </>
              }
            >
              {image9 ? (
                <div className="flex justify-content-center">
                  <Button
                    icon="pi pi-times"
                    className="p-button-danger p-button-rounded my-6 py-3 px-5 text-1xl"
                    onClick={() => {
                      const arrImages = [...images];
                      arrImages[8] = originalImages[8];
                      setImage9(null);
                      setImages(arrImages);
                    }}
                    label={localeText("removeImage")}
                  />
                </div>
              ) : (
                <FileUpload
                  uploadOptions={uploadOptions}
                  chooseLabel={localeText("choose")}
                  cancelLabel={localeText("cancel")}
                  name="demo"
                  onSelect={(e) => {
                    if (e.files[0].size / 1024 / 1024 > 5) {
                      fileUploadRef9.current.clear();
                      toast.current.show({
                        severity: "error",
                        summary: localeText("error"),
                        detail: localeText("fileSizeTooBig"),
                        life: 6000,
                      });
                      return false;
                    }

                    const arrImages = [...images];
                    arrImages[8] = e.files[0];
                    setImages(arrImages);
                    setImage9(e.files[0]);
                  }}
                  onClear={() => setImage9(null)}
                  onRemove={() => {
                    fileUploadRef9.current.clear();
                    const arrImages = [...images];
                    arrImages[8] = originalImages[8];
                    setImage8(null);
                    setImages(arrImages);
                  }}
                  onError={() => {
                    fileUploadRef9.current.clear();
                    const arrImages = [...images];
                    arrImages[8] = originalImages[8];
                    setImage9(null);
                    setImages(arrImages);
                  }}
                  onValidationFail={() => {
                    fileUploadRef9.current.clear();
                    const arrImages = [...images];
                    arrImages[8] = originalImages[8];
                    setImage9(null);
                    setImages(arrImages);
                  }}
                  accept="image/*"
                  ref={fileUploadRef9}
                  emptyTemplate={
                    <div className="text-center">
                      <i className="pi pi-upload text-400" style={{ fontSize: "2em" }}></i>
                      <h5 className="text-400">{localeText("dragImgFile")}</h5>
                    </div>
                  }
                  className="w-full h-auto"
                />
              )}
            </TabPanel>

            <TabPanel
              header={
                <>
                  {images[9] ? (
                    <div className="flex align-items-center">
                      <i className="pi pi-pencil mr-2"></i>
                      {localeText("image")} 10
                    </div>
                  ) : (
                    <>+ {localeText("add")}</>
                  )}
                </>
              }
            >
              {image10 ? (
                <div className="flex justify-content-center">
                  <Button
                    icon="pi pi-times"
                    className="p-button-danger p-button-rounded my-6 py-3 px-5 text-1xl"
                    onClick={() => {
                      const arrImages = [...images];
                      arrImages[9] = originalImages[9];
                      setImage10(null);
                      setImages(arrImages);
                    }}
                    label={localeText("removeImage")}
                  />
                </div>
              ) : (
                <FileUpload
                  uploadOptions={uploadOptions}
                  chooseLabel={localeText("choose")}
                  cancelLabel={localeText("cancel")}
                  name="demo"
                  onSelect={(e) => {
                    if (e.files[0].size / 1024 / 1024 > 5) {
                      fileUploadRef10.current.clear();
                      toast.current.show({
                        severity: "error",
                        summary: localeText("error"),
                        detail: localeText("fileSizeTooBig"),
                        life: 6000,
                      });
                      return false;
                    }

                    const arrImages = [...images];
                    arrImages[9] = e.files[0];
                    setImages(arrImages);
                    setImage10(e.files[0]);
                  }}
                  onClear={() => setImage10(null)}
                  onRemove={() => {
                    fileUploadRef10.current.clear();
                    const arrImages = [...images];
                    arrImages[9] = originalImages[9];
                    setImage9(null);
                    setImages(arrImages);
                  }}
                  onError={() => {
                    fileUploadRef10.current.clear();
                    const arrImages = [...images];
                    arrImages[9] = originalImages[9];
                    setImage10(null);
                    setImages(arrImages);
                  }}
                  onValidationFail={() => {
                    fileUploadRef10.current.clear();
                    const arrImages = [...images];
                    arrImages[9] = originalImages[9];
                    setImage10(null);
                    setImages(arrImages);
                  }}
                  accept="image/*"
                  ref={fileUploadRef10}
                  emptyTemplate={
                    <div className="text-center">
                      <i className="pi pi-upload text-400" style={{ fontSize: "2em" }}></i>
                      <h5 className="text-400">{localeText("dragImgFile")}</h5>
                    </div>
                  }
                  className="w-full h-auto"
                />
              )}
            </TabPanel>
          </TabView>

          <div className="my-4">
            <div className="grid">
              {product.productVariations.length === 0 ? (
                <>
                  <div className="lg:col-6 md:col-6 col-12">
                    <ul className="list-none m-0 p-0">
                      <li>
                        <label htmlFor="title">{localeText("title")}</label>
                      </li>
                      <li className="mt-2">
                        <InputText
                          className="w-full"
                          name="title"
                          value={title}
                          onChange={(e) => setTitle(e.target.value)}
                        />
                      </li>
                    </ul>
                  </div>
                  {typeProduct !== 3 && (
                    <div className="lg:col-6 md:col-6 col-12">
                      <ul className="list-none m-0 p-0">
                        <li>
                          <label htmlFor="stock">{localeText("stock")}</label>
                        </li>
                        <li className="mt-2">
                          <InputNumber
                            className="w-full"
                            name="stock"
                            value={stock}
                            onValueChange={(e) => setStock(e.value)}
                            disabled={!!product.product.productIdBanggood}
                          />
                          {product.product.productIdBanggood && (
                            <small>{localeText("banggoodStockLocked")}</small>
                          )}
                        </li>
                      </ul>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className="lg:col-6 md:col-6 col-12">
                    <ul className="list-none m-0 p-0">
                      <li>
                        <label htmlFor="title">{localeText("title")}</label>
                      </li>
                      <li className="mt-2">
                        <InputText
                          className="w-full"
                          name="title"
                          value={title}
                          onChange={(e) => setTitle(e.target.value)}
                        />
                      </li>
                    </ul>
                  </div>

                  <div className="lg:col-6 md:col-6 col-12">
                    <ul className="list-none m-0 p-0">
                      <li>
                        <label htmlFor="percentExtracoin">{localeText("percentExtracoin")}</label>
                      </li>
                      <li className="mt-2">
                        <InputNumber
                          className="w-full"
                          name="percentExtracoin"
                          min={percentMin}
                          max={percentMax}
                          value={percentExtraCoin}
                          onValueChange={(e) => setPercentExtracoin(e.value)}
                        />
                      </li>
                    </ul>
                  </div>
                </>
              )}
            </div>

            <label htmlFor="description">{localeText("description")}</label>
            {loaded && (
              <Editor
                headerTemplate={header}
                value={description}
                className="my-2"
                onTextChange={(e) => setDescription(DOMPurify.sanitize(e.htmlValue))}
                style={{ height: "256px" }}
              />
            )}

            {brands.length > 0 && NotDownloadableAndService && (
              <div className="w-full">
                <div className="lg:col-1 col-12 p-0 ml-2">
                  <label>{localeText("brand")}:</label>
                </div>
                <div className="lg:col-11 col-12 p-0">
                  <Dropdown
                    name="brands"
                    value={brand}
                    options={brands}
                    style={{ minWidth: "200px", width: "100%" }}
                    onChange={(e) => setBrand(e.value)}
                    className="my-2 mb-2 ml-2"
                  />
                </div>
              </div>
            )}

            {product.productVariations.length === 0 && (
              <div>
                <p className="font-bold text-lg p-0 m-0">
                  {localeText("banggoodPrice")}: {currency} {formatPrice(banggoodPrice)}
                </p>
                <p className="font-bold text-lg p-0 m-0">
                  {localeText("actualPrice")}: {currency}{" "}
                  {formatPrice(
                    product.product.priceUnique + product.product.priceUnique * PLATFORM_PRODUCT_FEE
                  )}
                </p>
                <p className="font-bold text-lg p-0 m-0">
                  {localeText("newPrice")}: {currency}{" "}
                  {formatPrice(
                    promotionalPriceUnique && hasDiscount
                      ? promotionalPriceUnique + promotionalPriceUnique * PLATFORM_PRODUCT_FEE
                      : priceUnique + priceUnique * PLATFORM_PRODUCT_FEE
                  )}
                </p>

                <p className="text-600 p-0 m-0">
                  {localeText("platformFee")}(5%): {currency}{" "}
                  {formatPrice(
                    promotionalPriceUnique && hasDiscount
                      ? promotionalPriceUnique * PLATFORM_PRODUCT_FEE
                      : priceUnique * PLATFORM_PRODUCT_FEE
                  )}
                </p>

                <p className="text-600 p-0 p-0 m-0">
                  Cashback: {currency}{" "}
                  {formatPrice(
                    (promotionalPriceUnique && hasDiscount ? promotionalPriceUnique : priceUnique) *
                      (percentExtraCoin / 100)
                  )}
                </p>

                {freight === 1 && freightPrice && (
                  <p className="text-600">
                    {localeText("freight")}: {freightPrice?.currency}{" "}
                    {formatPrice(freightPrice?.price)}
                  </p>
                )}
              </div>
            )}

            {product.productVariations.length === 0 ? (
              <div className="grid">
                <div className="lg:col-4 col-12">
                  <ul className="list-none m-0 p-0">
                    <li>
                      <label htmlFor="priceUnique" className="flex gap-2 align-items-center">
                        <span>{localeText("price")}</span>
                        {(isLoadingPrice || isLoadingFreight) && (
                          <i className="pi pi-spin pi-spinner text-600 text-sm my-2"></i>
                        )}
                      </label>
                    </li>
                    <li className="mt-2">
                      <InputNumber
                        mode="currency"
                        currency={currency}
                        locale={localeISO}
                        className="w-full"
                        name="priceUnique"
                        min={0}
                        value={priceUnique}
                        disabled={isLoadingPrice || isLoadingFreight}
                        onChange={(e) => setPriceUnique(e.value)}
                      />
                    </li>
                  </ul>
                </div>

                <div className="lg:col-4 col-12">
                  <ul className="p-0 m-0 list-none">
                    <li>
                      <label
                        htmlFor="promotionalPriceUnique"
                        className="flex gap-2 align-items-center"
                      >
                        <span>{localeText("promotionalPrice")}</span>
                        {isLoadingPrice && (
                          <i className="pi pi-spin pi-spinner text-600 text-sm my-2"></i>
                        )}
                      </label>

                      <InputNumber
                        mode="currency"
                        currency={currency}
                        disabled={!hasDiscount || isLoadingPrice || isLoadingFreight}
                        locale={localeISO}
                        min={0}
                        className="w-full mt-2"
                        name="promotionalPriceUnique"
                        value={promotionalPriceUnique}
                        onValueChange={(e) => setPromotionalPriceUnique(e.value)}
                      />
                    </li>
                    <li className="my-2">
                      <label htmlFor="hasdiscount">
                        <span className="text-700 text-sm">{localeText("doYouWantDiscount")}</span>
                      </label>
                      <Checkbox
                        name="hasdiscount"
                        onChange={(e) => setHasDiscount(e.checked)}
                        checked={hasDiscount}
                        className="ml-2"
                      ></Checkbox>
                    </li>
                  </ul>
                </div>

                <div className="lg:col-4 col-12">
                  <ul className="list-none m-0 p-0">
                    <li>
                      <label htmlFor="percentExtracoin">Cashback (%)</label>
                    </li>
                    <li className="mt-2">
                      <InputNumber
                        className="w-full"
                        name="percentExtracoin"
                        min={percentMin}
                        max={percentMax}
                        value={percentExtraCoin}
                        onValueChange={(e) => setPercentExtracoin(e.value)}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            ) : (
              <div className="mt-5 mb-6 flex justify-content-center">
                <p
                  onClick={() => {
                    setEditingProductObj(null);
                    getProductById(product.product.id, false);
                  }}
                  className="button-blank mobile-a text-xl"
                >
                  {localeText("thisProductHasVariationsEdit")}
                </p>
              </div>
            )}
            {category && category.id !== downloadableId && subcategories && subcategory !== 2 && (
              <ul className="list-none grid gap-2 p-0 m-0">
                <>
                  <div className="col-12 p-0">
                    <li>
                      <label htmlFor="productState">{localeText("productState")}</label>
                    </li>
                    <li className="mt-2">
                      <Dropdown
                        name="productState"
                        className="w-full"
                        value={productState}
                        options={productStates}
                        onChange={(e) => setProductState(e.value)}
                        placeholder={localeText("selectProductState")}
                      />
                    </li>
                  </div>
                  {productState === "USED" && (
                    <div className="lg:col-4 col-12">
                      <li>
                        <label htmlFor="productCondition">{localeText("condition")}</label>
                      </li>
                      <li className="mt-2">
                        <Dropdown
                          name="productCondition"
                          className="w-full"
                          value={productCondition}
                          options={productConditions}
                          onChange={(e) => setProductCondition(e.value)}
                          placeholder={localeText("selectCondition")}
                        />
                      </li>
                    </div>
                  )}
                </>
              </ul>
            )}
          </div>

          <ul className="p-0 m-0 mt-4 list-none">
            <li className="mb-2">
              <label htmlFor="hasdiscount">
                <span className="text-700">{localeText("wantToGivePercentageBeacuseShare")}</span>
              </label>
              <Checkbox
                name="hasdiscount"
                onChange={(e) => setHasComissionByShare(e.checked)}
                checked={hasComissionByShare}
                className="ml-2"
              ></Checkbox>
            </li>
            {hasComissionByShare && (
              <li>
                <label htmlFor="promotionalPriceUnique">
                  {localeText("specifyThePercentageOfThePersonWhoShares")} 0-100(%)
                </label>
                <InputNumber
                  disabled={!hasComissionByShare}
                  className="w-full my-2"
                  name="promotionalPriceUnique"
                  value={percentComissionByShare}
                  onValueChange={(e) => setPercentComissionByShare(e.value)}
                  min={0}
                  max={100}
                />
              </li>
            )}
          </ul>

          {shippingService && (
            <ul className="list-none mx-0 p-0">
              {!product.product.productIdBanggood && (
                <>
                  <li>
                    <h5 className="font-light">{localeText("productDimensions")}</h5>
                  </li>
                  <li>
                    <label htmlFor="height">{localeText("height")} (cm)</label>
                  </li>
                  <li>
                    <InputNumber
                      name="height"
                      className="my-2 w-full"
                      value={height}
                      min={1}
                      locale={localeISO}
                      onValueChange={(e) => {
                        if (e.value <= 0) {
                          toast.current.show({
                            severity: "error",
                            summary: localeText("error"),
                            detail: localeText("dimensionsGreaterThanZero"),
                            life: 6000,
                          });
                        } else setHeight(e.value);
                      }}
                      mode="decimal"
                      minFractionDigits={2}
                    />
                  </li>
                  <li>
                    <label htmlFor="width">{localeText("width")} (cm)</label>
                  </li>
                  <li>
                    <InputNumber
                      name="width"
                      className="my-2 w-full"
                      value={width}
                      min={1}
                      locale={localeISO}
                      onValueChange={(e) => {
                        if (e.value <= 0) {
                          toast.current.show({
                            severity: "error",
                            summary: localeText("error"),
                            detail: localeText("dimensionsGreaterThanZero"),
                            life: 6000,
                          });
                        } else setWidth(e.value);
                      }}
                      mode="decimal"
                      minFractionDigits={2}
                    />
                  </li>
                  <li>
                    <label htmlFor="length">{localeText("length")} (cm)</label>
                  </li>
                  <li>
                    <InputNumber
                      name="length"
                      className="my-2 w-full"
                      value={length}
                      min={1}
                      locale={localeISO}
                      onValueChange={(e) => {
                        if (e.value <= 0) {
                          toast.current.show({
                            severity: "error",
                            summary: localeText("error"),
                            detail: localeText("dimensionsGreaterThanZero"),
                            life: 6000,
                          });
                        } else setLength(e.value);
                      }}
                      mode="decimal"
                      minFractionDigits={2}
                    />
                  </li>

                  <li className="mt-2">
                    <h5 htmlFor="weight" className="mt-2 font-light">
                      {localeText("chooseWeightRange")} (kg)
                    </h5>
                    <div className="flex md:flex-row flex-column flex-wrap gap-3">
                      {weightInputs.map((weightInput, i) => (
                        <div key={i} className="flex align-items-center">
                          <RadioButton
                            inputId={`weight${i}`}
                            name={weightInput.name}
                            value={weightInput.value}
                            disabled={isLoadingFreight}
                            onChange={(e) => setWeight(e.value)}
                            checked={weight === weightInput.value}
                          />
                          <label htmlFor={`weight${i}`} className="ml-2 cursor-pointer">
                            {weightInput.label}
                          </label>
                        </div>
                      ))}
                    </div>
                  </li>
                </>
              )}
              <li>
                <h5 htmlFor="freight" className="mt-2 font-light">
                  {localeText("freight")}
                </h5>
                <div className="mt-2 flex md:flex-row flex-column flex-wrap gap-3">
                  {handledFreightInputs.map((freightInput, i) => {
                    if (
                      (props?.userInfo?.addressStatus === "NOT_ENABLED" ||
                        props?.userInfo?.addressStatus === "IN_ANALYSIS" ||
                        props?.userInfo?.country !== "IT") &&
                      freightInput.label === "free"
                    )
                      return null;
                    return (
                      <div key={i} className="flex align-items-center">
                        <RadioButton
                          inputId={`freight${i}`}
                          name={freightInput.name}
                          value={freightInput.value}
                          onChange={(e) => setFreight(e.value)}
                          checked={freight === freightInput.value}
                        />
                        <label htmlFor={`freight${i}`} className="ml-2 cursor-pointer">
                          {localeText(freightInput.label)}{" "}
                          {freightInput.label === "free" && `${localeText("withOurFright")}`}
                          {freightInput.label === "free2" && `(${localeText("withoutOurFright")})`}
                        </label>
                        <Tooltip target=".extracoin-tooltip" />
                        <i
                          className="pi pi-info-circle ml-1 extracoin-tooltip cursor-pointer text-600"
                          data-pr-tooltip={`${localeText(freightInput.explain)}`}
                          data-pr-position="right"
                          data-pr-at="right+5 top"
                          data-pr-my="left center-2"
                          tooltipoptions={{ event: "focus" }}
                        ></i>
                      </div>
                    );
                  })}
                </div>
                {freight === 1 && (
                  <>
                    <label htmlFor="postalCode">{localeText("zipCode")}</label>
                    <span className="p-input-icon-right w-full">
                      {isLoadingPostalCode && <i className="pi pi-spin pi-spinner" />}
                      <InputText
                        className="w-full my-2"
                        name="postalCode"
                        value={postalCode}
                        onChange={(e) => setPostalCode(e.target.value)}
                        onBlur={(e) => checkZipCode(e.target.value)}
                        disabled={isLoadingPostalCode}
                      />
                    </span>
                    <strong className="mt-1 mb-1 block">
                      {localeText("enterZipCodeToSimulateEndCustomer")}
                    </strong>
                    <Button
                      icon="pi pi-arrow-right"
                      label={localeText("simulate")}
                      iconPos="right"
                      disabled={isLoadingFreight}
                      loading={isLoadingFreight}
                      onClick={getLocationId}
                    />

                    {isLoadingFreight ? (
                      <div className="flex flex-row gap-2 align-items-center">
                        <Loading classNameContainer={"my-3 text-left"} disableMargin />
                        <p>{localeText("lookingTheBestShippingMethod")}</p>
                      </div>
                    ) : (
                      <>
                        {freightPrice && (
                          <div className="mt-2">
                            <strong>
                              {localeText("additionalShippingPriceProduct")}: {currency}{" "}
                              {formatPrice(freightPrice?.price)}
                            </strong>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </li>
            </ul>
          )}

          {typeProduct === 3 && (
            <>
              <label htmlFor="downloadproduct">
                <span className="text-xl font-bold">{localeText("uploadProductFile")}</span>
              </label>
              <FileUpload
                mode="basic"
                name="downloadproduct"
                ref={fileUploadDownloadable}
                className="mt-2"
                onSelect={(e) => {
                  const file = e.files[0];

                  if (file.size / 1024 / 1024 > 200) {
                    setDownloadableProduct(null);
                    fileUploadDownloadable.current.clear();
                    toast.current.show({
                      severity: "error",
                      summary: localeText("error"),
                      detail: localeText("fileSizeTooBig"),
                      life: 6000,
                    });
                    return false;
                  }

                  setDownloadableProduct(file);
                }}
                onClear={() => setDownloadableProduct(null)}
                onRemove={() => {
                  fileUploadDownloadable.current.clear();
                  setDownloadableProduct(null);
                }}
                onError={() => {
                  fileUploadDownloadable.current.clear();
                  setDownloadableProduct(null);
                }}
                onValidationFail={() => {
                  fileUploadDownloadable.current.clear();
                  setDownloadableProduct(null);
                }}
                accept={
                  downloadType === "AUDIO"
                    ? "audio/*"
                    : downloadType === "VIDEO"
                    ? "video/*"
                    : downloadType === "IMAGE"
                    ? "image/*"
                    : ".pdf, .txt, .doc, .docx, .epub, .mobi, .xlsx, .xls, .pptx, .ppt"
                }
              />
              <p className="text-600 mt-2">(max. 200 MB)</p>

              <label htmlFor="downloadproduct">
                <span className="text-xl font-bold">{localeText("uploadProductSampleFile")}</span>
              </label>
              <FileUpload
                mode="basic"
                name="downloadproduct"
                ref={fileUploadSample}
                className="mt-2"
                onSelect={(e) => {
                  const file = e.files[0];

                  if (file.size / 1024 / 1024 > 200) {
                    setSampleProduct(null);
                    fileUploadSample.current.clear();
                    toast.current.show({
                      severity: "error",
                      summary: localeText("error"),
                      detail: localeText("fileSizeTooBig"),
                      life: 6000,
                    });
                    return false;
                  }

                  setSampleProduct(file);
                }}
                onClear={() => setSampleProduct(null)}
                onRemove={() => {
                  fileUploadSample.current.clear();
                  setSampleProduct(null);
                }}
                onError={() => {
                  fileUploadSample.current.clear();
                  setSampleProduct(null);
                }}
                onValidationFail={() => {
                  fileUploadSample.current.clear();
                  setSampleProduct(null);
                }}
                accept={
                  downloadType === "AUDIO"
                    ? "audio/*"
                    : downloadType === "VIDEO"
                    ? "video/*"
                    : downloadType === "IMAGE"
                    ? "image/*"
                    : ".pdf, .txt, .doc, .docx, .epub, .mobi, .xlsx, .xls, .pptx, .ppt"
                }
              />
              <p className="text-600 mt-2">(max. 200 MB)</p>
            </>
          )}

          {plan === "Manager" && (
            <>
              <h5 className="font-light mt-4">{localeText("productTechnicalInfo")}</h5>
              <div className="grid mb-6 mx-0">
                <div className="col-6 p-1">
                  <p className="font-bold">{localeText("fieldName")}</p>
                </div>
                <div className="col-6 p-1">
                  <p className="font-bold">{localeText("fieldValue")}</p>
                </div>
                <div className="col-6 p-1">
                  <InputText
                    className="mr-2 w-full"
                    value={techInfoKey1}
                    onChange={(e) => setTechInfoKey1(e.target.value)}
                  />
                </div>
                <div className="col-6 p-1">
                  <div className="flex">
                    <InputText
                      className="w-full"
                      value={techInfoValue1}
                      onChange={(e) => setTechInfoValue1(e.target.value)}
                    />
                    {techInfoKey1.length > 0 && techInfoValue1.length > 0 && (
                      <Button
                        icon="pi pi-trash"
                        className="p-button-danger p-button-rounded ml-2"
                        onClick={() => clearTechInfo(technicalInfo[0].id, 0)}
                      />
                    )}
                  </div>
                </div>
                <div className="col-6 p-1">
                  <InputText
                    className="mr-2 w-full"
                    value={techInfoKey2}
                    onChange={(e) => setTechInfoKey2(e.target.value)}
                  />
                </div>
                <div className="col-6 p-1">
                  <div className="flex">
                    <InputText
                      className="w-full"
                      value={techInfoValue2}
                      onChange={(e) => setTechInfoValue2(e.target.value)}
                    />
                    {techInfoKey2.length > 0 && techInfoValue2.length > 0 && (
                      <Button
                        icon="pi pi-trash"
                        className="p-button-danger p-button-rounded ml-2"
                        onClick={() => clearTechInfo(technicalInfo[1].id, 1)}
                      />
                    )}
                  </div>
                </div>
                <div className="col-6 p-1">
                  <InputText
                    className="mr-2 w-full"
                    value={techInfoKey3}
                    onChange={(e) => setTechInfoKey3(e.target.value)}
                  />
                </div>
                <div className="col-6 p-1">
                  <div className="flex">
                    <InputText
                      className="w-full"
                      value={techInfoValue3}
                      onChange={(e) => setTechInfoValue3(e.target.value)}
                    />
                    {techInfoKey3.length > 0 && techInfoValue3.length > 0 && (
                      <Button
                        icon="pi pi-trash"
                        className="p-button-danger p-button-rounded ml-2"
                        onClick={() => clearTechInfo(technicalInfo[2].id, 2)}
                      />
                    )}
                  </div>
                </div>
                <div className="col-6 p-1">
                  <InputText
                    className="mr-2 w-full"
                    value={techInfoKey4}
                    onChange={(e) => setTechInfoKey4(e.target.value)}
                  />
                </div>
                <div className="col-6 p-1">
                  <div className="flex">
                    <InputText
                      className="w-full"
                      value={techInfoValue4}
                      onChange={(e) => setTechInfoValue4(e.target.value)}
                    />
                    {techInfoKey4.length > 0 && techInfoValue4.length > 0 && (
                      <Button
                        icon="pi pi-trash"
                        className="p-button-danger p-button-rounded ml-2"
                        onClick={() => clearTechInfo(technicalInfo[3].id, 3)}
                      />
                    )}
                  </div>
                </div>
                <div className="col-6 p-1">
                  <InputText
                    className="mr-2 w-full"
                    value={techInfoKey5}
                    onChange={(e) => setTechInfoKey5(e.target.value)}
                  />
                </div>
                <div className="col-6 p-1">
                  <div className="flex">
                    <InputText
                      className="w-full"
                      value={techInfoValue5}
                      onChange={(e) => setTechInfoValue5(e.target.value)}
                    />
                    {techInfoKey5.length > 0 && techInfoValue5.length > 0 && (
                      <Button
                        icon="pi pi-trash"
                        className="p-button-danger p-button-rounded ml-2"
                        onClick={() => clearTechInfo(technicalInfo[4].id, 4)}
                      />
                    )}
                  </div>
                </div>
              </div>
            </>
          )}

          <div className="text-center mb-6">
            <Button
              label={localeText("confirmChanges")}
              onClick={() => confirmChanges()}
              loading={loading || isLoadingFreight || isLoadingPrice}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default EditingProduct;
